import Se, { forwardRef as X, useState as Ba, useMemo as da, useCallback as C, useRef as ga, useEffect as La, useId as Fa, useImperativeHandle as ai, Component as ei, createElement as ii } from "react";
import { LoadingIndicatorSpinner as ni } from "@storeblocks/spinner-loading-indicator";
import f, { css as g } from "styled-components";
import { SystemIcon as _a } from "@storeblocks/icon";
import { InputField as ri } from "@storeblocks/input-molecules";
import { AlertInline as Qa } from "@storeblocks/inline-alert";
import { Label as li } from "@storeblocks/label";
import { useSwitch as oi } from "@storebrand-digital/react-hooks";
import { isDefined as Ca } from "@storebrand-digital/bank-foundation-utils";
import ti from "merge-refs";
import si from "dompurify";
import { Legend as we } from "@storeblocks/legend";
import { Alert as ci } from "@storeblocks/alert";
import { LinearLoadingIndicator as di } from "@storeblocks/linear-loading-indicator";
var Ga = { exports: {} }, ka = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pe;
function mi() {
  if (pe) return ka;
  pe = 1;
  var e = Se, n = Symbol.for("react.element"), o = Symbol.for("react.fragment"), t = Object.prototype.hasOwnProperty, c = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(h, p, R) {
    var S, d = {}, I = null, E = null;
    R !== void 0 && (I = "" + R), p.key !== void 0 && (I = "" + p.key), p.ref !== void 0 && (E = p.ref);
    for (S in p) t.call(p, S) && !u.hasOwnProperty(S) && (d[S] = p[S]);
    if (h && h.defaultProps) for (S in p = h.defaultProps, p) d[S] === void 0 && (d[S] = p[S]);
    return { $$typeof: n, type: h, key: I, ref: E, props: d, _owner: c.current };
  }
  return ka.Fragment = o, ka.jsx = b, ka.jsxs = b, ka;
}
var ja = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var he;
function gi() {
  return he || (he = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), o = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), h = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), v = Symbol.iterator, G = "@@iterator";
    function F(i) {
      if (i === null || typeof i != "object")
        return null;
      var r = v && i[v] || i[G];
      return typeof r == "function" ? r : null;
    }
    var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function j(i) {
      {
        for (var r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), m = 1; m < r; m++)
          s[m - 1] = arguments[m];
        y("error", i, s);
      }
    }
    function y(i, r, s) {
      {
        var m = B.ReactDebugCurrentFrame, w = m.getStackAddendum();
        w !== "" && (r += "%s", s = s.concat([w]));
        var T = s.map(function(x) {
          return String(x);
        });
        T.unshift("Warning: " + r), Function.prototype.apply.call(console[i], console, T);
      }
    }
    var J = !1, $ = !1, M = !1, q = !1, H = !1, z;
    z = Symbol.for("react.module.reference");
    function ya(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === t || i === u || H || i === c || i === R || i === S || q || i === E || J || $ || M || typeof i == "object" && i !== null && (i.$$typeof === I || i.$$typeof === d || i.$$typeof === b || i.$$typeof === h || i.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === z || i.getModuleId !== void 0));
    }
    function Oa(i, r, s) {
      var m = i.displayName;
      if (m)
        return m;
      var w = r.displayName || r.name || "";
      return w !== "" ? s + "(" + w + ")" : s;
    }
    function fa(i) {
      return i.displayName || "Context";
    }
    function W(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case t:
          return "Fragment";
        case o:
          return "Portal";
        case u:
          return "Profiler";
        case c:
          return "StrictMode";
        case R:
          return "Suspense";
        case S:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case h:
            var r = i;
            return fa(r) + ".Consumer";
          case b:
            var s = i;
            return fa(s._context) + ".Provider";
          case p:
            return Oa(i, i.render, "ForwardRef");
          case d:
            var m = i.displayName || null;
            return m !== null ? m : W(i.type) || "Memo";
          case I: {
            var w = i, T = w._payload, x = w._init;
            try {
              return W(x(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, U = 0, Ia, pa, Z, ha, Aa, aa, Ta;
    function Pa() {
    }
    Pa.__reactDisabledLog = !0;
    function za() {
      {
        if (U === 0) {
          Ia = console.log, pa = console.info, Z = console.warn, ha = console.error, Aa = console.group, aa = console.groupCollapsed, Ta = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: Pa,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        U++;
      }
    }
    function Ka() {
      {
        if (U--, U === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, i, {
              value: Ia
            }),
            info: O({}, i, {
              value: pa
            }),
            warn: O({}, i, {
              value: Z
            }),
            error: O({}, i, {
              value: ha
            }),
            group: O({}, i, {
              value: Aa
            }),
            groupCollapsed: O({}, i, {
              value: aa
            }),
            groupEnd: O({}, i, {
              value: Ta
            })
          });
        }
        U < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ba = B.ReactCurrentDispatcher, oa;
    function A(i, r, s) {
      {
        if (oa === void 0)
          try {
            throw Error();
          } catch (w) {
            var m = w.stack.trim().match(/\n( *(at )?)/);
            oa = m && m[1] || "";
          }
        return `
` + oa + i;
      }
    }
    var P = !1, V;
    {
      var ea = typeof WeakMap == "function" ? WeakMap : Map;
      V = new ea();
    }
    function ia(i, r) {
      if (!i || P)
        return "";
      {
        var s = V.get(i);
        if (s !== void 0)
          return s;
      }
      var m;
      P = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = ba.current, ba.current = null, za();
      try {
        if (r) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (D) {
              m = D;
            }
            Reflect.construct(i, [], x);
          } else {
            try {
              x.call();
            } catch (D) {
              m = D;
            }
            i.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (D) {
            m = D;
          }
          i();
        }
      } catch (D) {
        if (D && m && typeof D.stack == "string") {
          for (var k = D.stack.split(`
`), _ = m.stack.split(`
`), N = k.length - 1, L = _.length - 1; N >= 1 && L >= 0 && k[N] !== _[L]; )
            L--;
          for (; N >= 1 && L >= 0; N--, L--)
            if (k[N] !== _[L]) {
              if (N !== 1 || L !== 1)
                do
                  if (N--, L--, L < 0 || k[N] !== _[L]) {
                    var K = `
` + k[N].replace(" at new ", " at ");
                    return i.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", i.displayName)), typeof i == "function" && V.set(i, K), K;
                  }
                while (N >= 1 && L >= 0);
              break;
            }
        }
      } finally {
        P = !1, ba.current = T, Ka(), Error.prepareStackTrace = w;
      }
      var sa = i ? i.displayName || i.name : "", na = sa ? A(sa) : "";
      return typeof i == "function" && V.set(i, na), na;
    }
    function Ea(i, r, s) {
      return ia(i, !1);
    }
    function Ne(i) {
      var r = i.prototype;
      return !!(r && r.isReactComponent);
    }
    function Ma(i, r, s) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return ia(i, Ne(i));
      if (typeof i == "string")
        return A(i);
      switch (i) {
        case R:
          return A("Suspense");
        case S:
          return A("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case p:
            return Ea(i.render);
          case d:
            return Ma(i.type, r, s);
          case I: {
            var m = i, w = m._payload, T = m._init;
            try {
              return Ma(T(w), r, s);
            } catch {
            }
          }
        }
      return "";
    }
    var va = Object.prototype.hasOwnProperty, ee = {}, ie = B.ReactDebugCurrentFrame;
    function Na(i) {
      if (i) {
        var r = i._owner, s = Ma(i.type, i._source, r ? r.type : null);
        ie.setExtraStackFrame(s);
      } else
        ie.setExtraStackFrame(null);
    }
    function Ge(i, r, s, m, w) {
      {
        var T = Function.call.bind(va);
        for (var x in i)
          if (T(i, x)) {
            var k = void 0;
            try {
              if (typeof i[x] != "function") {
                var _ = Error((m || "React class") + ": " + s + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              k = i[x](r, x, m, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              k = N;
            }
            k && !(k instanceof Error) && (Na(w), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", s, x, typeof k), Na(null)), k instanceof Error && !(k.message in ee) && (ee[k.message] = !0, Na(w), j("Failed %s type: %s", s, k.message), Na(null));
          }
      }
    }
    var $e = Array.isArray;
    function Ha(i) {
      return $e(i);
    }
    function Le(i) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, s = r && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return s;
      }
    }
    function Be(i) {
      try {
        return ne(i), !1;
      } catch {
        return !0;
      }
    }
    function ne(i) {
      return "" + i;
    }
    function re(i) {
      if (Be(i))
        return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Le(i)), ne(i);
    }
    var le = B.ReactCurrentOwner, Fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, oe, te;
    function _e(i) {
      if (va.call(i, "ref")) {
        var r = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function De(i) {
      if (va.call(i, "key")) {
        var r = Object.getOwnPropertyDescriptor(i, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function ye(i, r) {
      typeof i.ref == "string" && le.current;
    }
    function Oe(i, r) {
      {
        var s = function() {
          oe || (oe = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        s.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function ze(i, r) {
      {
        var s = function() {
          te || (te = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        s.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Ke = function(i, r, s, m, w, T, x) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: i,
        key: r,
        ref: s,
        props: x,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function He(i, r, s, m, w) {
      {
        var T, x = {}, k = null, _ = null;
        s !== void 0 && (re(s), k = "" + s), De(r) && (re(r.key), k = "" + r.key), _e(r) && (_ = r.ref, ye(r, w));
        for (T in r)
          va.call(r, T) && !Fe.hasOwnProperty(T) && (x[T] = r[T]);
        if (i && i.defaultProps) {
          var N = i.defaultProps;
          for (T in N)
            x[T] === void 0 && (x[T] = N[T]);
        }
        if (k || _) {
          var L = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          k && Oe(x, L), _ && ze(x, L);
        }
        return Ke(i, k, _, w, m, le.current, x);
      }
    }
    var Ua = B.ReactCurrentOwner, se = B.ReactDebugCurrentFrame;
    function ta(i) {
      if (i) {
        var r = i._owner, s = Ma(i.type, i._source, r ? r.type : null);
        se.setExtraStackFrame(s);
      } else
        se.setExtraStackFrame(null);
    }
    var Va;
    Va = !1;
    function Wa(i) {
      return typeof i == "object" && i !== null && i.$$typeof === n;
    }
    function ce() {
      {
        if (Ua.current) {
          var i = W(Ua.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function Ue(i) {
      return "";
    }
    var de = {};
    function Ve(i) {
      {
        var r = ce();
        if (!r) {
          var s = typeof i == "string" ? i : i.displayName || i.name;
          s && (r = `

Check the top-level render call using <` + s + ">.");
        }
        return r;
      }
    }
    function me(i, r) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var s = Ve(r);
        if (de[s])
          return;
        de[s] = !0;
        var m = "";
        i && i._owner && i._owner !== Ua.current && (m = " It was passed a child from " + W(i._owner.type) + "."), ta(i), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, m), ta(null);
      }
    }
    function ge(i, r) {
      {
        if (typeof i != "object")
          return;
        if (Ha(i))
          for (var s = 0; s < i.length; s++) {
            var m = i[s];
            Wa(m) && me(m, r);
          }
        else if (Wa(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var w = F(i);
          if (typeof w == "function" && w !== i.entries)
            for (var T = w.call(i), x; !(x = T.next()).done; )
              Wa(x.value) && me(x.value, r);
        }
      }
    }
    function We(i) {
      {
        var r = i.type;
        if (r == null || typeof r == "string")
          return;
        var s;
        if (typeof r == "function")
          s = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === d))
          s = r.propTypes;
        else
          return;
        if (s) {
          var m = W(r);
          Ge(s, i.props, "prop", m, i);
        } else if (r.PropTypes !== void 0 && !Va) {
          Va = !0;
          var w = W(r);
          j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ye(i) {
      {
        for (var r = Object.keys(i.props), s = 0; s < r.length; s++) {
          var m = r[s];
          if (m !== "children" && m !== "key") {
            ta(i), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ta(null);
            break;
          }
        }
        i.ref !== null && (ta(i), j("Invalid attribute `ref` supplied to `React.Fragment`."), ta(null));
      }
    }
    var ue = {};
    function fe(i, r, s, m, w, T) {
      {
        var x = ya(i);
        if (!x) {
          var k = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = Ue();
          _ ? k += _ : k += ce();
          var N;
          i === null ? N = "null" : Ha(i) ? N = "array" : i !== void 0 && i.$$typeof === n ? (N = "<" + (W(i.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : N = typeof i, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, k);
        }
        var L = He(i, r, s, w, T);
        if (L == null)
          return L;
        if (x) {
          var K = r.children;
          if (K !== void 0)
            if (m)
              if (Ha(K)) {
                for (var sa = 0; sa < K.length; sa++)
                  ge(K[sa], i);
                Object.freeze && Object.freeze(K);
              } else
                j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ge(K, i);
        }
        if (va.call(r, "key")) {
          var na = W(i), D = Object.keys(r).filter(function(Ce) {
            return Ce !== "key";
          }), Ya = D.length > 0 ? "{key: someKey, " + D.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ue[na + Ya]) {
            var Qe = D.length > 0 ? "{" + D.join(": ..., ") + ": ...}" : "{}";
            j(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ya, na, Qe, na), ue[na + Ya] = !0;
          }
        }
        return i === t ? Ye(L) : We(L), L;
      }
    }
    function Je(i, r, s) {
      return fe(i, r, s, !0);
    }
    function qe(i, r, s) {
      return fe(i, r, s, !1);
    }
    var Ze = qe, Xe = Je;
    ja.Fragment = t, ja.jsx = Ze, ja.jsxs = Xe;
  }()), ja;
}
var be;
function ui() {
  return be || (be = 1, process.env.NODE_ENV === "production" ? Ga.exports = mi() : Ga.exports = gi()), Ga.exports;
}
var l = ui();
const fi = f.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $isFixed: e }) => e ? g`
          top: 0;
          left: 0;
          position: fixed;
        ` : g`
          position: relative;
        `};

  ${({ $hasOverlay: e }) => e ? g`
          background: rgba(255, 255, 255, 0.8);
        ` : g`
          pointer-events: none;
        `}
`, pi = { Wrapper: fi };
function On({
  hasOverlay: e,
  isFixed: n,
  size: o,
  colorVariant: t,
  ...c
}) {
  return /* @__PURE__ */ l.jsx(pi.Wrapper, { ...c, $isFixed: n, $hasOverlay: e, children: /* @__PURE__ */ l.jsx(ni, { size: o, colorVariant: t }) });
}
const hi = f.ul`
  padding-inline-start: unset;
`, Re = f(_a)`
  width: ${({ size: e }) => e - 1}px;
  height: ${({ size: e }) => e - 1}px;
  font-size: ${({ size: e }) => e + 1}px;
`, bi = f.li`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: var(--p-spacing-24);

  ${Re} {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: var(--p-spacing-24);
  }
`, Ja = {
  CheckCircle: Re,
  ListItem: bi,
  List: hi
};
function zn({ items: e, iconSize: n = 24 }) {
  return /* @__PURE__ */ l.jsx(Ja.List, { children: e.map((o) => /* @__PURE__ */ l.jsxs(Ja.ListItem, { children: [
    /* @__PURE__ */ l.jsx(Ja.CheckCircle, { name: "check-circle", size: n }),
    o
  ] }, o)) });
}
var Da = /* @__PURE__ */ ((e) => (e.S = "599px", e.M = "839px", e.L = "1129px", e))(Da || {}), Y = /* @__PURE__ */ ((e) => (e.S = "600px", e.M = "840px", e.L = "1130px", e))(Y || {});
const Ei = f.div`
  box-sizing: border-box;
  padding: var(--p-spacing-16);

  width: 100%;
  position: relative;

  @media only screen and (min-width: ${Y.S}) {
    max-width: calc(${Y.S} + calc(var(--p-spacing-32) * 2));
    margin-left: auto;
    margin-right: auto;
  }
`, Ie = X((e, n) => /* @__PURE__ */ l.jsx(Ei, { ...e, ref: n }));
var Q = /* @__PURE__ */ ((e) => (e.RED = "RED", e.LIGHT_RED = "LIGHT_RED", e.GREEN = "GREEN", e.LIGHT_GREEN = "LIGHT_GREEN", e.DARK_GREEN = "DARK_GREEN", e.ORANGE = "ORANGE", e.YELLOW = "YELLOW", e))(Q || {});
const vi = {
  [Q.RED]: "#a62611",
  [Q.LIGHT_RED]: "#dc4606",
  [Q.GREEN]: "#3a8b26",
  [Q.LIGHT_GREEN]: "#7eb210",
  [Q.DARK_GREEN]: "#006d46",
  [Q.ORANGE]: "#e48900",
  [Q.YELLOW]: "#f1bf0d"
}, ki = f.div`
  background-color: rgba(25, 25, 25, 0.05);
  border-radius: 100px;
  display: flex;
  height: 20px;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
`, ji = f.div`
  min-width: 10px;
  flex: 1 1 auto;

  ${({ $color: e }) => e && g`
      background-color: ${vi[e]};
    `};

  border-right: ${({ $color: e }) => g`1px solid rgba(255, 255, 255, ${e ? 0.4 : 1})`};
`, Ee = { Row: ki, Cell: ji }, Kn = X(
  ({ max: e, value: n, color: o, ...t }, c) => /* @__PURE__ */ l.jsx(Ee.Row, { ...t, ref: c, children: Array.from({ length: e }, (u, b) => /* @__PURE__ */ l.jsx(
    Ee.Cell,
    {
      role: "presentation",
      $color: n > b ? o : void 0
    },
    `energy-bar-cell-${b}`
  )) })
);
function xi(e) {
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      ...e,
      fill: "none",
      viewBox: "0 0 22 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M22 9.3a2 2 0 00-.795-1.596l-9-6.794a2 2 0 00-2.41 0l-9 6.794A2 2 0 000 9.3V22a2 2 0 002 2h18a2 2 0 002-2z",
          fill: "currentColor"
        }
      )
    }
  );
}
var ma = /* @__PURE__ */ ((e) => (e.DARK_GREEN = "DarkGreen", e.LIGHT_GREEN = "LightGreen", e.YELLOW = "Yellow", e.ORANGE = "Orange", e.RED = "Red", e))(ma || {});
const Si = f.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  pointer-events: none;
  line-height: 22px;

  &* {
    pointer-events: none;
  }
`, wi = f.span`
  position: absolute;
  color: white;
  font-size: 14px;
  width: 20px;
  text-align: center;
`, Ri = f(xi)`
  width: 23px;
  height: 23px;
  color: ${({ $energyMix: e }) => {
  switch (e) {
    case ma.DARK_GREEN:
      return "#009900";
    case ma.LIGHT_GREEN:
      return "#99CC00";
    case ma.YELLOW:
      return "#FFFF00";
    case ma.ORANGE:
      return "#FF9901";
    case ma.RED:
      return "#FF0000";
    default:
      return "grey";
  }
}};
`, qa = {
  HouseIcon: Ri,
  Container: Si,
  Letter: wi
};
function Hn({ energyRating: e, energyMix: n }) {
  return /* @__PURE__ */ l.jsxs(qa.Container, { children: [
    /* @__PURE__ */ l.jsx(qa.HouseIcon, { $energyMix: n }),
    /* @__PURE__ */ l.jsx(qa.Letter, { children: e ?? "?" })
  ] });
}
const Un = f.div`
  @media only screen and (min-width: ${Y.S}) {
    padding: var(--p-spacing-32);
    border: var(--p-border-medium) solid var(--p-color-grey-100);
    border-radius: var(--p-corner-radius-medium);
  }
`;
function Ii({ $isTruncated: e }) {
  return e && g`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `;
}
function Ai({ $styleAs: e }) {
  switch (e) {
    case "h1":
      return g`
        font-family: 'Storebrand Display', sans-serif;

        @media only screen and (min-width: ${Y.S}) {
          line-height: 42px;
        }
      `;
    case "h2":
      return g`
        font-family: 'Storebrand Display', sans-serif;

        @media only screen and (min-width: ${Y.S}) {
          line-height: 34px;
        }
      `;
    default:
      return g`
        font-family: 'Storebrand Display', sans-serif;
      `;
  }
}
const Ti = f.h1.attrs(({ $styleAs: e, className: n }) => ({
  className: [n, e].join(" ")
}))`
  ${Ii}

  ${Ai}
`, Pi = { Heading: Ti }, Ae = X(({ htmlTag: e, styleAs: n, isTruncated: o, children: t, ...c }, u) => /* @__PURE__ */ l.jsx(
  Pi.Heading,
  {
    ...c,
    ref: u,
    as: e,
    $styleAs: n ?? e,
    $isTruncated: o,
    children: t
  }
)), Vn = X(
  ({
    value: e = "",
    onValueChange: n,
    onChange: o,
    onBlur: t,
    onFocus: c,
    formatter: u,
    alertMessage: b,
    alertMessageType: h,
    ...p
  }, R) => {
    const [S, d] = Ba(!1), I = e.replace(/[^\d.,]/g, ""), E = I && u ? u(I) : I, v = S ? I : E;
    function G(j) {
      d(!0), c == null || c(j);
    }
    function F(j) {
      d(!1), t == null || t(j);
    }
    function B(j) {
      const y = j.target.value.replace(/[^\d.,]/g, "");
      n == null || n(y), o == null || o({ ...j, target: { ...j.target, value: y } });
    }
    return /* @__PURE__ */ l.jsx(
      ri,
      {
        ...p,
        onBlur: F,
        onFocus: G,
        onChange: B,
        ref: R,
        value: v,
        alertMessage: b ?? "",
        alertMessageType: b ? h : void 0
      }
    );
  }
), Mi = f.span`
  --size: var(--p-spacing-${({ $size: e }) => e});

  ${({ $axis: e }) => e === "horizontal" ? g`
          display: inline-block;
          width: var(--size);
          max-width: var(--size);
          min-width: var(--size);
        ` : g`
          display: block;
          height: var(--size);
          max-height: var(--size);
          min-height: var(--size);
        `}
  ${({ $display: e }) => e && g`
      display: ${e};
    `}
`, Ni = { Spacer: Mi };
function ua({ axis: e = "vertical", size: n, display: o }) {
  return /* @__PURE__ */ l.jsx(Ni.Spacer, { $axis: e, $size: n, "aria-hidden": !0, $display: o });
}
function Gi(e, n = 0) {
  if (e.length > 0 && !(n in e))
    throw Error("Initial index is out of bounds");
  const [o, t] = Ba(n in e ? n : 0), { length: c } = e, u = e[o], b = o !== Math.max(c - 1, 0), h = o !== 0, p = C(() => {
    t((d) => d === c - 1 ? d : d + 1);
  }, [c]), R = C(() => {
    t((d) => d === 0 ? 0 : d - 1);
  }, []), S = C(
    (d) => {
      if (d in e)
        t(d);
      else
        throw Error("Given index is out of bounds");
    },
    [e]
  );
  return {
    index: o,
    value: u,
    length: c,
    hasPrevious: h,
    hasNext: b,
    previous: R,
    next: p,
    setIndex: S
  };
}
function $i(e, n = 0) {
  const { value: o, index: t, setIndex: c, length: u } = Gi(e, n), b = C(() => {
    const p = t === u - 1 ? 0 : t + 1;
    p in e && c(p);
  }, [t, u, e, c]), h = C(() => {
    const p = t === 0 ? u - 1 : t - 1;
    p in e && c(p);
  }, [t, u, e, c]);
  return {
    index: t,
    value: o,
    length: u,
    previous: h,
    next: b,
    setIndex: c
  };
}
function Li({
  countries: e,
  preferredCountries: n = [],
  value: o
}) {
  const t = da(
    () => new Set(n),
    [n]
  ), c = da(
    () => [...t].map(
      (E) => e.find(({ id: v }) => v === E)
    ).filter(Ca),
    [e, t]
  ), u = da(
    () => e.filter(({ id: E }) => !t.has(E)).sort((E, v) => E.name.localeCompare(v.name)),
    [e, t]
  ), b = da(
    () => [...c, ...u],
    [c, u]
  ), h = da(() => {
    const E = b.findIndex(({ id: v }) => o === v);
    return E >= 0 ? E : 0;
  }, [b, o]), {
    value: p,
    index: R,
    next: S,
    previous: d,
    setIndex: I
  } = $i(b, h);
  return {
    countryDropdownList: b,
    next: S,
    previous: d,
    setIndex: I,
    currentIndex: R,
    country: p
  };
}
const Bi = f.div`
  width: calc(100% + 4px);
  margin-left: -2px;
  top: 2rem;
  border: 2px solid var(--p-color-red-800);
  border-radius: var(--p-corner-radius-small);
  position: absolute;
  margin-top: 1rem;

  background-color: white;
  z-index: 2;
  max-height: 288px;
  overflow: auto;

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    text-align: left;
    background: none;
    border: 0;
    user-select: none;
    padding: var(--p-spacing-08);
    cursor: pointer;
    display: flex;
    justify-content: space-between;

    &:not(:first-child) {
      border-top: solid 1px rgba(25, 25, 25, 0.16);
    }

    &[data-highlighted='true'] {
      // Whole value is exposed as --outline in Storeblocks, but we just need the colour
      box-shadow: #0000ff 0 0 0 2px inset;
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background-color: var(--color-overlay-hover-darken);
      }
    }
  }
`, Fi = { CountryDropdown: Bi };
function _i({
  countries: e,
  id: n,
  label: o = "Velg land",
  onClose: t,
  onCountrySelect: c,
  onActiveDescendantChange: u,
  preferredCountries: b,
  value: h,
  ...p
}) {
  const R = `${n}-list-item`, { countryDropdownList: S, next: d, previous: I, currentIndex: E, country: v } = Li({
    countries: e,
    preferredCountries: b,
    value: h
  }), G = ga(void 0), F = ga([]), B = ($) => (M) => {
    M && (F.current[$] = M);
  }, j = C(
    ($) => {
      c == null || c($), t == null || t();
    },
    [c, t]
  ), y = C(
    ($) => {
      switch ($.key) {
        case "Escape":
          t == null || t();
          break;
        case "ArrowDown":
          d();
          break;
        case "ArrowUp":
          I();
          break;
        case "Enter":
        case " ": {
          $.preventDefault();
          const M = v == null ? void 0 : v.id;
          if (!M)
            break;
          j(M);
          break;
        }
      }
    },
    [t, d, I, v == null ? void 0 : v.id, j]
  ), J = C(($) => {
    if (Ca($) && $ >= 0) {
      const M = F.current[$];
      G.current && window.cancelAnimationFrame(G.current), G.current = window.requestAnimationFrame(
        () => M == null ? void 0 : M.scrollIntoView({
          block: "center"
        })
      );
    }
  }, []);
  return La(() => {
    v != null && v.id && (u == null || u(`${R}-${v.id}`));
  }, [u, R, v == null ? void 0 : v.id]), La(() => {
    J(E);
  }, [J, E]), La(() => (window.addEventListener("keydown", y), () => window.removeEventListener("keydown", y)), [y]), /* @__PURE__ */ l.jsx(Fi.CountryDropdown, { ...p, children: /* @__PURE__ */ l.jsx("ul", { role: "listbox", "aria-label": o, id: n, children: S.map(
    ({ name: $, flagEmoji: M, callingCode: q, id: H }, z) => /* @__PURE__ */ l.jsxs(
      "li",
      {
        "aria-selected": E === z,
        id: `${R}-${H}`,
        ref: B(z),
        role: "option",
        onMouseDown: () => j(H),
        ...E === z ? { "data-highlighted": !0 } : void 0,
        children: [
          /* @__PURE__ */ l.jsxs("span", { children: [
            M,
            " ",
            $
          ] }),
          /* @__PURE__ */ l.jsx("span", { children: q })
        ]
      },
      H
    )
  ) }) });
}
var a = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.AlandIslands = "AX", e.Albania = "AL", e.Algeria = "DZ", e.AmericanSamoa = "AS", e.Andorra = "AD", e.Angola = "AO", e.Anguilla = "AI", e.Antarctica = "AQ", e.AntiguaAndBarbuda = "AG", e.Argentina = "AR", e.Armenia = "AM", e.Aruba = "AW", e.Australia = "AU", e.Austria = "AT", e.Azerbaijan = "AZ", e.Bahamas = "BS", e.Bahrain = "BH", e.Bangladesh = "BD", e.Barbados = "BB", e.Belarus = "BY", e.Belgium = "BE", e.Belize = "BZ", e.Benin = "BJ", e.Bermuda = "BM", e.Bhutan = "BT", e.Bolivia = "BO", e.BosniaAndHerzegovina = "BA", e.Botswana = "BW", e.Brazil = "BR", e.BritishIndianOceanTerritory = "IO", e.BruneiDarussalam = "BN", e.Bulgaria = "BG", e.BurkinaFaso = "BF", e.Burundi = "BI", e.Cambodia = "KH", e.Cameroon = "CM", e.Canada = "CA", e.CapeVerde = "CV", e.CaymanIslands = "KY", e.CentralAfricanRepublic = "CF", e.Chad = "TD", e.Chile = "CL", e.China = "CN", e.ChristmasIsland = "CX", e.CocosIslands = "CC", e.Colombia = "CO", e.Comoros = "KM", e.Congo = "CG", e.CongoTheDemocraticRepublicOfTheCongo = "CD", e.CookIslands = "CK", e.CostaRica = "CR", e.CoteDIvoire = "CI", e.Croatia = "HR", e.Cuba = "CU", e.Cyprus = "CY", e.CzechRepublic = "CZ", e.Denmark = "DK", e.Djibouti = "DJ", e.Dominica = "DM", e.DominicanRepublic = "DO", e.Ecuador = "EC", e.Egypt = "EG", e.ElSalvador = "SV", e.EquatorialGuinea = "GQ", e.Eritrea = "ER", e.Estonia = "EE", e.Ethiopia = "ET", e.FalklandIslands = "FK", e.FaroeIslands = "FO", e.Fiji = "FJ", e.Finland = "FI", e.France = "FR", e.FrenchGuiana = "GF", e.FrenchPolynesia = "PF", e.Gabon = "GA", e.Gambia = "GM", e.Georgia = "GE", e.Germany = "DE", e.Ghana = "GH", e.Gibraltar = "GI", e.Greece = "GR", e.Greenland = "GL", e.Grenada = "GD", e.Guadeloupe = "GP", e.Guam = "GU", e.Guatemala = "GT", e.Guernsey = "GG", e.Guinea = "GN", e.GuineaBissau = "GW", e.Guyana = "GY", e.Haiti = "HT", e.Vatican = "VA", e.Honduras = "HN", e.HongKong = "HK", e.Hungary = "HU", e.Iceland = "IS", e.India = "IN", e.Indonesia = "ID", e.Iran = "IR", e.Iraq = "IQ", e.Ireland = "IE", e.IsleOfMan = "IM", e.Israel = "IL", e.Italy = "IT", e.Jamaica = "JM", e.Japan = "JP", e.Jersey = "JE", e.Jordan = "JO", e.Kazakhstan = "KZ", e.Kenya = "KE", e.Kiribati = "KI", e.NorthKorea = "KP", e.SouthKorea = "KR", e.Kuwait = "KW", e.Kyrgyzstan = "KG", e.Laos = "LA", e.Latvia = "LV", e.Lebanon = "LB", e.Lesotho = "LS", e.Liberia = "LR", e.Libya = "LY", e.Liechtenstein = "LI", e.Lithuania = "LT", e.Luxembourg = "LU", e.Macao = "MO", e.Macedonia = "MK", e.Madagascar = "MG", e.Malawi = "MW", e.Malaysia = "MY", e.Maldives = "MV", e.Mali = "ML", e.Malta = "MT", e.MarshallIslands = "MH", e.Martinique = "MQ", e.Mauritania = "MR", e.Mauritius = "MU", e.Mayotte = "YT", e.Mexico = "MX", e.Micronesia = "FM", e.Moldova = "MD", e.Monaco = "MC", e.Mongolia = "MN", e.Montenegro = "ME", e.Montserrat = "MS", e.Morocco = "MA", e.Mozambique = "MZ", e.Myanmar = "MM", e.Namibia = "NA", e.Nauru = "NR", e.Nepal = "NP", e.Netherlands = "NL", e.NetherlandsAntilles = "AN", e.NewCaledonia = "NC", e.NewZealand = "NZ", e.Nicaragua = "NI", e.Niger = "NE", e.Nigeria = "NG", e.Niue = "NU", e.NorfolkIsland = "NF", e.NorthernMarianaIslands = "MP", e.Norway = "NO", e.Oman = "OM", e.Pakistan = "PK", e.Palau = "PW", e.PalestinianTerritory = "PS", e.Panama = "PA", e.PapuaNewGuinea = "PG", e.Paraguay = "PY", e.Peru = "PE", e.Philippines = "PH", e.Pitcairn = "PN", e.Poland = "PL", e.Portugal = "PT", e.PuertoRico = "PR", e.Qatar = "QA", e.Romania = "RO", e.Russia = "RU", e.Rwanda = "RW", e.Reunion = "RE", e.SaintBarthelemy = "BL", e.SaintHelena = "SH", e.SaintKittsAndNevis = "KN", e.SaintLucia = "LC", e.SaintMartin = "MF", e.SaintPierreAndMiquelon = "PM", e.SaintVincentAndTheGrenadines = "VC", e.Samoa = "WS", e.SanMarino = "SM", e.SaoTomeAndPrincipe = "ST", e.SaudiArabia = "SA", e.Senegal = "SN", e.Serbia = "RS", e.Seychelles = "SC", e.SierraLeone = "SL", e.Singapore = "SG", e.Slovakia = "SK", e.Slovenia = "SI", e.SolomonIslands = "SB", e.Somalia = "SO", e.SouthAfrica = "ZA", e.SouthSudan = "SS", e.SouthGeorgiaAndTheSouthSandwichIslands = "GS", e.Spain = "ES", e.SriLanka = "LK", e.Sudan = "SD", e.Suriname = "SR", e.SvalbardAndJanMayen = "SJ", e.Swaziland = "SZ", e.Sweden = "SE", e.Switzerland = "CH", e.Syria = "SY", e.Taiwan = "TW", e.Tajikistan = "TJ", e.Tanzania = "TZ", e.Thailand = "TH", e.TimorLeste = "TL", e.Togo = "TG", e.Tokelau = "TK", e.Tonga = "TO", e.TrinidadAndTobago = "TT", e.Tunisia = "TN", e.Turkey = "TR", e.Turkmenistan = "TM", e.TurksAndCaicosIslands = "TC", e.Tuvalu = "TV", e.Uganda = "UG", e.Ukraine = "UA", e.UnitedArabEmirates = "AE", e.UnitedKingdom = "GB", e.UnitedStates = "US", e.Uruguay = "UY", e.Uzbekistan = "UZ", e.Vanuatu = "VU", e.Venezuela = "VE", e.Vietnam = "VN", e.BritishVirginIslands = "VG", e.VirginIslands = "VI", e.WallisAndFutuna = "WF", e.Yemen = "YE", e.Zambia = "ZM", e.Zimbabwe = "ZW", e))(a || {});
const Di = "🌐", yi = /(?!^\+)[^\d]/g, xa = {
  [a.Afghanistan]: {
    id: a.Afghanistan,
    name: "Afghanistan",
    callingCode: "+93",
    flagEmoji: "🇦🇫",
    mask: "##-###-####"
  },
  [a.AlandIslands]: {
    id: a.AlandIslands,
    name: "Aland Islands",
    callingCode: "+358",
    flagEmoji: "🇦🇽",
    mask: "(###)###-##-##"
  },
  [a.Albania]: {
    id: a.Albania,
    name: "Albania",
    callingCode: "+355",
    flagEmoji: "🇦🇱",
    mask: "(###)###-###"
  },
  [a.Algeria]: {
    id: a.Algeria,
    name: "Algeria",
    callingCode: "+213",
    flagEmoji: "🇩🇿",
    mask: "##-###-####"
  },
  [a.AmericanSamoa]: {
    id: a.AmericanSamoa,
    name: "American Samoa",
    callingCode: "+1684",
    flagEmoji: "🇦🇸",
    mask: "###-####"
  },
  [a.Andorra]: {
    id: a.Andorra,
    name: "Andorra",
    callingCode: "+376",
    flagEmoji: "🇦🇩",
    mask: "###-###"
  },
  [a.Angola]: {
    id: a.Angola,
    name: "Angola",
    callingCode: "+244",
    flagEmoji: "🇦🇴",
    mask: "(###)###-###"
  },
  [a.Anguilla]: {
    id: a.Anguilla,
    name: "Anguilla",
    callingCode: "+1264",
    flagEmoji: "🇦🇮",
    mask: "###-####"
  },
  [a.Antarctica]: {
    id: a.Antarctica,
    name: "Antarctica",
    callingCode: "+672",
    flagEmoji: "🇦🇶",
    mask: "1##-###"
  },
  [a.AntiguaAndBarbuda]: {
    id: a.AntiguaAndBarbuda,
    name: "Antigua and Barbuda",
    callingCode: "+1268",
    flagEmoji: "🇦🇬",
    mask: "###-####"
  },
  [a.Argentina]: {
    id: a.Argentina,
    name: "Argentina",
    callingCode: "+54",
    flagEmoji: "🇦🇷",
    mask: "(###)###-####"
  },
  [a.Armenia]: {
    id: a.Armenia,
    name: "Armenia",
    callingCode: "+374",
    flagEmoji: "🇦🇲",
    mask: "##-###-###"
  },
  [a.Aruba]: {
    id: a.Aruba,
    name: "Aruba",
    callingCode: "+297",
    flagEmoji: "🇦🇼",
    mask: "###-####"
  },
  [a.Australia]: {
    id: a.Australia,
    name: "Australia",
    callingCode: "+61",
    flagEmoji: "🇦🇺",
    mask: "#-####-####"
  },
  [a.Austria]: {
    id: a.Austria,
    name: "Austria",
    callingCode: "+43",
    flagEmoji: "🇦🇹",
    mask: "(###)###-####"
  },
  [a.Azerbaijan]: {
    id: a.Azerbaijan,
    name: "Azerbaijan",
    callingCode: "+994",
    flagEmoji: "🇦🇿",
    mask: "##-###-##-##"
  },
  [a.Bahamas]: {
    id: a.Bahamas,
    name: "Bahamas",
    callingCode: "+1242",
    flagEmoji: "🇧🇸",
    mask: "###-####"
  },
  [a.Bahrain]: {
    id: a.Bahrain,
    name: "Bahrain",
    callingCode: "+973",
    flagEmoji: "🇧🇭",
    mask: "####-####"
  },
  [a.Bangladesh]: {
    id: a.Bangladesh,
    name: "Bangladesh",
    callingCode: "+880",
    flagEmoji: "🇧🇩",
    mask: "1###-######"
  },
  [a.Barbados]: {
    id: a.Barbados,
    name: "Barbados",
    callingCode: "+1246",
    flagEmoji: "🇧🇧",
    mask: "###-####"
  },
  [a.Belarus]: {
    id: a.Belarus,
    name: "Belarus",
    callingCode: "+375",
    flagEmoji: "🇧🇾",
    mask: "(##)###-##-##"
  },
  [a.Belgium]: {
    id: a.Belgium,
    name: "Belgium",
    callingCode: "+32",
    flagEmoji: "🇧🇪",
    mask: "(###)###-###"
  },
  [a.Belize]: {
    id: a.Belize,
    name: "Belize",
    callingCode: "+501",
    flagEmoji: "🇧🇿",
    mask: "###-####"
  },
  [a.Benin]: {
    id: a.Benin,
    name: "Benin",
    callingCode: "+229",
    flagEmoji: "🇧🇯",
    mask: "##-##-####"
  },
  [a.Bermuda]: {
    id: a.Bermuda,
    name: "Bermuda",
    callingCode: "+1441",
    flagEmoji: "🇧🇲",
    mask: "###-####"
  },
  [a.Bhutan]: {
    id: a.Bhutan,
    name: "Bhutan",
    callingCode: "+975",
    flagEmoji: "🇧🇹",
    mask: ["17-###-###", "77-###-###", "#-###-###"]
  },
  [a.Bolivia]: {
    id: a.Bolivia,
    name: "Bolivia, Plurinational State of",
    callingCode: "+591",
    flagEmoji: "🇧🇴",
    mask: "#-###-####"
  },
  [a.BosniaAndHerzegovina]: {
    id: a.BosniaAndHerzegovina,
    name: "Bosnia and Herzegovina",
    callingCode: "+387",
    flagEmoji: "🇧🇦",
    mask: ["##-####", "##-#####"]
  },
  [a.Botswana]: {
    id: a.Botswana,
    name: "Botswana",
    callingCode: "+267",
    flagEmoji: "🇧🇼",
    mask: "##-###-###"
  },
  [a.Brazil]: {
    id: a.Brazil,
    name: "Brazil",
    callingCode: "+55",
    flagEmoji: "🇧🇷",
    mask: ["(##)####-####", "(##)#####-####"]
  },
  [a.BritishIndianOceanTerritory]: {
    id: a.BritishIndianOceanTerritory,
    name: "British Indian Ocean Territory",
    callingCode: "+246",
    flagEmoji: "🇮🇴",
    mask: "###-####"
  },
  [a.BruneiDarussalam]: {
    id: a.BruneiDarussalam,
    name: "Brunei Darussalam",
    callingCode: "+673",
    flagEmoji: "🇧🇳",
    mask: "###-####"
  },
  [a.Bulgaria]: {
    id: a.Bulgaria,
    name: "Bulgaria",
    callingCode: "+359",
    flagEmoji: "🇧🇬",
    mask: "(###)###-###"
  },
  [a.BurkinaFaso]: {
    id: a.BurkinaFaso,
    name: "Burkina Faso",
    callingCode: "+226",
    flagEmoji: "🇧🇫",
    mask: "##-##-####"
  },
  [a.Burundi]: {
    id: a.Burundi,
    name: "Burundi",
    callingCode: "+257",
    flagEmoji: "🇧🇮",
    mask: "##-##-####"
  },
  [a.Cambodia]: {
    id: a.Cambodia,
    name: "Cambodia",
    callingCode: "+855",
    flagEmoji: "🇰🇭",
    mask: "##-###-###"
  },
  [a.Cameroon]: {
    id: a.Cameroon,
    name: "Cameroon",
    callingCode: "+237",
    flagEmoji: "🇨🇲",
    mask: "####-####"
  },
  [a.CapeVerde]: {
    id: a.CapeVerde,
    name: "Cape Verde",
    callingCode: "+238",
    flagEmoji: "🇨🇻",
    mask: "(###)##-##"
  },
  [a.CaymanIslands]: {
    id: a.CaymanIslands,
    name: "Cayman Islands",
    callingCode: "+1345",
    flagEmoji: "🇰🇾",
    mask: "###-####"
  },
  [a.CentralAfricanRepublic]: {
    id: a.CentralAfricanRepublic,
    name: "Central African Republic",
    callingCode: "+236",
    flagEmoji: "🇨🇫",
    mask: "##-##-####"
  },
  [a.Chad]: {
    id: a.Chad,
    name: "Chad",
    callingCode: "+235",
    flagEmoji: "🇹🇩",
    mask: "##-##-##-##"
  },
  [a.Chile]: {
    id: a.Chile,
    name: "Chile",
    callingCode: "+56",
    flagEmoji: "🇨🇱",
    mask: "#-####-####"
  },
  [a.China]: {
    id: a.China,
    name: "China",
    callingCode: "+86",
    flagEmoji: "🇨🇳",
    mask: ["(###)####-###", "(###)####-####", "##-#####-#####"]
  },
  [a.ChristmasIsland]: {
    id: a.ChristmasIsland,
    name: "Christmas Island",
    callingCode: "+61",
    flagEmoji: "🇨🇽",
    mask: "#-####-####"
  },
  [a.CocosIslands]: {
    id: a.CocosIslands,
    name: "Cocos (Keeling) Islands",
    callingCode: "+61",
    flagEmoji: "🇨🇨",
    mask: "#-####-####"
  },
  [a.Colombia]: {
    id: a.Colombia,
    name: "Colombia",
    callingCode: "+57",
    flagEmoji: "🇨🇴",
    mask: "(###)###-####"
  },
  [a.Comoros]: {
    id: a.Comoros,
    name: "Comoros",
    callingCode: "+269",
    flagEmoji: "🇰🇲",
    mask: "##-#####"
  },
  [a.Congo]: {
    id: a.Congo,
    name: "Congo",
    callingCode: "+242",
    flagEmoji: "🇨🇬",
    mask: "##-#####"
  },
  [a.CongoTheDemocraticRepublicOfTheCongo]: {
    id: a.CongoTheDemocraticRepublicOfTheCongo,
    name: "Congo, The Democratic Republic of the Congo",
    callingCode: "+243",
    flagEmoji: "🇨🇩",
    mask: "(###)###-###"
  },
  [a.CookIslands]: {
    id: a.CookIslands,
    name: "Cook Islands",
    callingCode: "+682",
    flagEmoji: "🇨🇰",
    mask: "##-###"
  },
  [a.CostaRica]: {
    id: a.CostaRica,
    name: "Costa Rica",
    callingCode: "+506",
    flagEmoji: "🇨🇷",
    mask: "####-####"
  },
  [a.CoteDIvoire]: {
    id: a.CoteDIvoire,
    name: "Cote d'Ivoire",
    callingCode: "+225",
    flagEmoji: "🇨🇮",
    mask: "##-###-###"
  },
  [a.Croatia]: {
    id: a.Croatia,
    name: "Croatia",
    callingCode: "+385",
    flagEmoji: "🇭🇷",
    mask: "##-###-###"
  },
  [a.Cuba]: {
    id: a.Cuba,
    name: "Cuba",
    callingCode: "+53",
    flagEmoji: "🇨🇺",
    mask: "#-###-####"
  },
  [a.Cyprus]: {
    id: a.Cyprus,
    name: "Cyprus",
    callingCode: "+357",
    flagEmoji: "🇨🇾",
    mask: "##-###-###"
  },
  [a.CzechRepublic]: {
    id: a.CzechRepublic,
    name: "Czech Republic",
    callingCode: "+420",
    flagEmoji: "🇨🇿",
    mask: "(###)###-###"
  },
  [a.Denmark]: {
    id: a.Denmark,
    name: "Denmark",
    callingCode: "+45",
    flagEmoji: "🇩🇰",
    mask: "##-##-##-##"
  },
  [a.Djibouti]: {
    id: a.Djibouti,
    name: "Djibouti",
    callingCode: "+253",
    flagEmoji: "🇩🇯",
    mask: "##-##-##-##"
  },
  [a.Dominica]: {
    id: a.Dominica,
    name: "Dominica",
    callingCode: "+1767",
    flagEmoji: "🇩🇲",
    mask: "###-####"
  },
  [a.DominicanRepublic]: {
    id: a.DominicanRepublic,
    name: "Dominican Republic",
    callingCode: "+1849",
    flagEmoji: "🇩🇴",
    mask: "###-####"
  },
  [a.Ecuador]: {
    id: a.Ecuador,
    name: "Ecuador",
    callingCode: "+593",
    flagEmoji: "🇪🇨",
    mask: ["#-###-####", "##-###-####"]
  },
  [a.Egypt]: {
    id: a.Egypt,
    name: "Egypt",
    callingCode: "+20",
    flagEmoji: "🇪🇬",
    mask: "(###)###-####"
  },
  [a.ElSalvador]: {
    id: a.ElSalvador,
    name: "El Salvador",
    callingCode: "+503",
    flagEmoji: "🇸🇻",
    mask: "##-##-####"
  },
  [a.EquatorialGuinea]: {
    id: a.EquatorialGuinea,
    name: "Equatorial Guinea",
    callingCode: "+240",
    flagEmoji: "🇬🇶",
    mask: "##-###-####"
  },
  [a.Eritrea]: {
    id: a.Eritrea,
    name: "Eritrea",
    callingCode: "+291",
    flagEmoji: "🇪🇷",
    mask: "#-###-###"
  },
  [a.Estonia]: {
    id: a.Estonia,
    name: "Estonia",
    callingCode: "+372",
    flagEmoji: "🇪🇪",
    mask: ["###-####", "####-####"]
  },
  [a.Ethiopia]: {
    id: a.Ethiopia,
    name: "Ethiopia",
    callingCode: "+251",
    flagEmoji: "🇪🇹",
    mask: "##-###-####"
  },
  [a.FalklandIslands]: {
    id: a.FalklandIslands,
    name: "Falkland Islands (Malvinas)",
    callingCode: "+500",
    flagEmoji: "🇫🇰",
    mask: "#####"
  },
  [a.FaroeIslands]: {
    id: a.FaroeIslands,
    name: "Faroe Islands",
    callingCode: "+298",
    flagEmoji: "🇫🇴",
    mask: "###-###"
  },
  [a.Fiji]: {
    id: a.Fiji,
    name: "Fiji",
    callingCode: "+679",
    flagEmoji: "🇫🇯",
    mask: "##-#####"
  },
  [a.Finland]: {
    id: a.Finland,
    name: "Finland",
    callingCode: "+358",
    flagEmoji: "🇫🇮",
    mask: "(###)###-##-##"
  },
  [a.France]: {
    id: a.France,
    name: "France",
    callingCode: "+33",
    flagEmoji: "🇫🇷",
    mask: "(###)###-###"
  },
  [a.FrenchGuiana]: {
    id: a.FrenchGuiana,
    name: "French Guiana",
    callingCode: "+594",
    flagEmoji: "🇬🇫",
    mask: "#####-####"
  },
  [a.FrenchPolynesia]: {
    id: a.FrenchPolynesia,
    name: "French Polynesia",
    callingCode: "+689",
    flagEmoji: "🇵🇫",
    mask: "##-##-##"
  },
  [a.Gabon]: {
    id: a.Gabon,
    name: "Gabon",
    callingCode: "+241",
    flagEmoji: "🇬🇦",
    mask: "#-##-##-##"
  },
  [a.Gambia]: {
    id: a.Gambia,
    name: "Gambia",
    callingCode: "+220",
    flagEmoji: "🇬🇲",
    mask: "(###)##-##"
  },
  [a.Georgia]: {
    id: a.Georgia,
    name: "Georgia",
    callingCode: "+995",
    flagEmoji: "🇬🇪",
    mask: "(###)###-###"
  },
  [a.Germany]: {
    id: a.Germany,
    name: "Germany",
    callingCode: "+49",
    flagEmoji: "🇩🇪",
    mask: [
      "###-###",
      "(###)##-##",
      "(###)##-###",
      "(###)##-####",
      "(###)###-####",
      "(####)###-####"
    ]
  },
  [a.Ghana]: {
    id: a.Ghana,
    name: "Ghana",
    callingCode: "+233",
    flagEmoji: "🇬🇭",
    mask: "(###)###-###"
  },
  [a.Gibraltar]: {
    id: a.Gibraltar,
    name: "Gibraltar",
    callingCode: "+350",
    flagEmoji: "🇬🇮",
    mask: "###-#####"
  },
  [a.Greece]: {
    id: a.Greece,
    name: "Greece",
    callingCode: "+30",
    flagEmoji: "🇬🇷",
    mask: "(###)###-####"
  },
  [a.Greenland]: {
    id: a.Greenland,
    name: "Greenland",
    callingCode: "+299",
    flagEmoji: "🇬🇱",
    mask: "##-##-##"
  },
  [a.Grenada]: {
    id: a.Grenada,
    name: "Grenada",
    callingCode: "+1473",
    flagEmoji: "🇬🇩",
    mask: "###-####"
  },
  [a.Guadeloupe]: {
    id: a.Guadeloupe,
    name: "Guadeloupe",
    callingCode: "+590",
    flagEmoji: "🇬🇵",
    mask: "(###)###-###"
  },
  [a.Guam]: {
    id: a.Guam,
    name: "Guam",
    callingCode: "+1671",
    flagEmoji: "🇬🇺",
    mask: "###-####"
  },
  [a.Guatemala]: {
    id: a.Guatemala,
    name: "Guatemala",
    callingCode: "+502",
    flagEmoji: "🇬🇹",
    mask: "#-###-####"
  },
  [a.Guernsey]: {
    id: a.Guernsey,
    name: "Guernsey",
    callingCode: "+441481",
    flagEmoji: "🇬🇬",
    mask: "######"
  },
  [a.Guinea]: {
    id: a.Guinea,
    name: "Guinea",
    callingCode: "+224",
    flagEmoji: "🇬🇳",
    mask: "##-###-###"
  },
  [a.GuineaBissau]: {
    id: a.GuineaBissau,
    name: "Guinea-Bissau",
    callingCode: "+245",
    flagEmoji: "🇬🇼",
    mask: "#-######"
  },
  [a.Guyana]: {
    id: a.Guyana,
    name: "Guyana",
    callingCode: "+595",
    flagEmoji: "🇬🇾",
    mask: "(###)###-###"
  },
  [a.Haiti]: {
    id: a.Haiti,
    name: "Haiti",
    callingCode: "+509",
    flagEmoji: "🇭🇹",
    mask: "##-##-####"
  },
  [a.Vatican]: {
    id: a.Vatican,
    name: "Holy See (Vatican City State)",
    callingCode: "+3906698",
    flagEmoji: "🇻🇦",
    mask: "#####"
  },
  [a.Honduras]: {
    id: a.Honduras,
    name: "Honduras",
    callingCode: "+504",
    flagEmoji: "🇭🇳",
    mask: "####-####"
  },
  [a.HongKong]: {
    id: a.HongKong,
    name: "Hong Kong",
    callingCode: "+852",
    flagEmoji: "🇭🇰",
    mask: "####-####"
  },
  [a.Hungary]: {
    id: a.Hungary,
    name: "Hungary",
    callingCode: "+36",
    flagEmoji: "🇭🇺",
    mask: "(###)###-###"
  },
  [a.Iceland]: {
    id: a.Iceland,
    name: "Iceland",
    callingCode: "+354",
    flagEmoji: "🇮🇸",
    mask: "###-####"
  },
  [a.India]: {
    id: a.India,
    name: "India",
    callingCode: "+91",
    flagEmoji: "🇮🇳",
    mask: "(####)###-###"
  },
  [a.Indonesia]: {
    id: a.Indonesia,
    name: "Indonesia",
    callingCode: "+62",
    flagEmoji: "🇮🇩",
    mask: [
      "##-###-##",
      "##-###-###",
      "##-###-####",
      "(8##)###-###",
      "(8##)###-##-###"
    ]
  },
  [a.Iran]: {
    id: a.Iran,
    name: "Iran, Islamic Republic of Persian Gulf",
    callingCode: "+98",
    flagEmoji: "🇮🇷",
    mask: "(###)###-####"
  },
  [a.Iraq]: {
    id: a.Iraq,
    name: "Iraq",
    callingCode: "+964",
    flagEmoji: "🇮🇷",
    mask: "(###)###-####"
  },
  [a.Ireland]: {
    id: a.Ireland,
    name: "Ireland",
    callingCode: "+353",
    flagEmoji: "🇮🇪",
    mask: "(###)###-###"
  },
  [a.IsleOfMan]: {
    id: a.IsleOfMan,
    name: "Isle of Man",
    callingCode: "+441624",
    flagEmoji: "🇮🇲",
    mask: "######"
  },
  [a.Israel]: {
    id: a.Israel,
    name: "Israel",
    callingCode: "+972",
    flagEmoji: "🇮🇱",
    mask: ["#-###-####", "5#-###-####"]
  },
  [a.Italy]: {
    id: a.Italy,
    name: "Italy",
    callingCode: "+39",
    flagEmoji: "🇮🇹",
    mask: "06 698#####"
  },
  [a.Jamaica]: {
    id: a.Jamaica,
    name: "Jamaica",
    callingCode: "+1876",
    flagEmoji: "🇯🇲",
    mask: "###-####"
  },
  [a.Japan]: {
    id: a.Japan,
    name: "Japan",
    callingCode: "+81",
    flagEmoji: "🇯🇵",
    mask: ["(###)###-###", "##-####-####"]
  },
  [a.Jersey]: {
    id: a.Jersey,
    name: "Jersey",
    callingCode: "+441534",
    flagEmoji: "🇯🇪",
    mask: "####-######"
  },
  [a.Jordan]: {
    id: a.Jordan,
    name: "Jordan",
    callingCode: "+962",
    flagEmoji: "🇯🇴",
    mask: "#-####-####"
  },
  [a.Kazakhstan]: {
    id: a.Kazakhstan,
    name: "Kazakhstan",
    callingCode: "+77",
    flagEmoji: "🇰🇿",
    mask: ["(6##)###-##-##", "(7##)###-##-##"]
  },
  [a.Kenya]: {
    id: a.Kenya,
    name: "Kenya",
    callingCode: "+254",
    flagEmoji: "🇰🇪",
    mask: "###-######"
  },
  [a.Kiribati]: {
    id: a.Kiribati,
    name: "Kiribati",
    callingCode: "+686",
    flagEmoji: "🇰🇮",
    mask: "##-###"
  },
  [a.NorthKorea]: {
    id: a.NorthKorea,
    name: "Korea, Democratic People's Republic of Korea",
    callingCode: "+850",
    flagEmoji: "🇰🇵",
    mask: [
      "###-###",
      "####-####",
      "##-###-###",
      "###-####-###",
      "191-###-####",
      "####-#############"
    ]
  },
  [a.SouthKorea]: {
    id: a.SouthKorea,
    name: "Korea, Republic of South Korea",
    callingCode: "+82",
    flagEmoji: "🇰🇷",
    mask: "##-###-####"
  },
  [a.Kuwait]: {
    id: a.Kuwait,
    name: "Kuwait",
    callingCode: "+965",
    flagEmoji: "🇰🇼",
    mask: "####-####"
  },
  [a.Kyrgyzstan]: {
    id: a.Kyrgyzstan,
    name: "Kyrgyzstan",
    callingCode: "+996",
    flagEmoji: "🇰🇬",
    mask: "(###)###-###"
  },
  [a.Laos]: {
    id: a.Laos,
    name: "Laos",
    callingCode: "+856",
    flagEmoji: "🇱🇦",
    mask: ["##-###-###", "(20##)###-###"]
  },
  [a.Latvia]: {
    id: a.Latvia,
    name: "Latvia",
    callingCode: "+371",
    flagEmoji: "🇱🇻",
    mask: "##-###-###"
  },
  [a.Lebanon]: {
    id: a.Lebanon,
    name: "Lebanon",
    callingCode: "+961",
    flagEmoji: "🇱🇧",
    mask: ["#-###-###", "##-###-###"]
  },
  [a.Lesotho]: {
    id: a.Lesotho,
    name: "Lesotho",
    callingCode: "+266",
    flagEmoji: "🇱🇸",
    mask: "#-###-####"
  },
  [a.Liberia]: {
    id: a.Liberia,
    name: "Liberia",
    callingCode: "+231",
    flagEmoji: "🇱🇷",
    mask: "##-###-###"
  },
  [a.Libya]: {
    id: a.Libya,
    name: "Libyan Arab Jamahiriya",
    callingCode: "+218",
    flagEmoji: "🇱🇾",
    mask: ["##-###-###", "21-###-####"]
  },
  [a.Liechtenstein]: {
    id: a.Liechtenstein,
    name: "Liechtenstein",
    callingCode: "+423",
    flagEmoji: "🇱🇮",
    mask: "(###)###-####"
  },
  [a.Lithuania]: {
    id: a.Lithuania,
    name: "Lithuania",
    callingCode: "+370",
    flagEmoji: "🇱🇹",
    mask: "(###)##-###"
  },
  [a.Luxembourg]: {
    id: a.Luxembourg,
    name: "Luxembourg",
    callingCode: "+352",
    flagEmoji: "🇱🇺",
    mask: "(###)###-###"
  },
  [a.Macao]: {
    id: a.Macao,
    name: "Macao",
    callingCode: "+853",
    flagEmoji: "🇲🇴",
    mask: "####-####"
  },
  [a.Macedonia]: {
    id: a.Macedonia,
    name: "Macedonia",
    callingCode: "+389",
    flagEmoji: "🇲🇰",
    mask: "##-###-###"
  },
  [a.Madagascar]: {
    id: a.Madagascar,
    name: "Madagascar",
    callingCode: "+261",
    flagEmoji: "🇲🇬",
    mask: "##-##-#####"
  },
  [a.Malawi]: {
    id: a.Malawi,
    name: "Malawi",
    callingCode: "+265",
    flagEmoji: "🇲🇼",
    mask: ["1-###-###", "#-####-####"]
  },
  [a.Malaysia]: {
    id: a.Malaysia,
    name: "Malaysia",
    callingCode: "+60",
    flagEmoji: "🇲🇾",
    mask: ["#-###-###", "##-###-###", "(###)###-###", "##-###-####"]
  },
  [a.Maldives]: {
    id: a.Maldives,
    name: "Maldives",
    callingCode: "+960",
    flagEmoji: "🇲🇻",
    mask: "###-####"
  },
  [a.Mali]: {
    id: a.Mali,
    name: "Mali",
    callingCode: "+223",
    flagEmoji: "🇲🇱",
    mask: "##-##-####"
  },
  [a.Malta]: {
    id: a.Malta,
    name: "Malta",
    callingCode: "+356",
    flagEmoji: "🇲🇹",
    mask: "####-####"
  },
  [a.MarshallIslands]: {
    id: a.MarshallIslands,
    name: "Marshall Islands",
    callingCode: "+692",
    flagEmoji: "🇲🇭",
    mask: "###-####"
  },
  [a.Martinique]: {
    id: a.Martinique,
    name: "Martinique",
    callingCode: "+596",
    flagEmoji: "🇲🇶",
    mask: "(###)##-##-##"
  },
  [a.Mauritania]: {
    id: a.Mauritania,
    name: "Mauritania",
    callingCode: "+222",
    flagEmoji: "🇲🇷",
    mask: "##-##-####"
  },
  [a.Mauritius]: {
    id: a.Mauritius,
    name: "Mauritius",
    callingCode: "+230",
    flagEmoji: "🇲🇺",
    mask: "###-####"
  },
  [a.Mayotte]: {
    id: a.Mayotte,
    name: "Mayotte",
    callingCode: "+262",
    flagEmoji: "🇾🇹",
    mask: "#####-####"
  },
  [a.Mexico]: {
    id: a.Mexico,
    name: "Mexico",
    callingCode: "+52",
    flagEmoji: "🇲🇽",
    mask: ["##-##-####", "(###)###-####"]
  },
  [a.Micronesia]: {
    id: a.Micronesia,
    name: "Micronesia, Federated States of Micronesia",
    callingCode: "+691",
    flagEmoji: "🇫🇲",
    mask: "###-####"
  },
  [a.Moldova]: {
    id: a.Moldova,
    name: "Moldova",
    callingCode: "+373",
    flagEmoji: "🇲🇩",
    mask: "####-####"
  },
  [a.Monaco]: {
    id: a.Monaco,
    name: "Monaco",
    callingCode: "+377",
    flagEmoji: "🇲🇨",
    mask: ["##-###-###", "(###)###-###"]
  },
  [a.Mongolia]: {
    id: a.Mongolia,
    name: "Mongolia",
    callingCode: "+976",
    flagEmoji: "🇲🇳",
    mask: "##-##-####"
  },
  [a.Montenegro]: {
    id: a.Montenegro,
    name: "Montenegro",
    callingCode: "+382",
    flagEmoji: "🇲🇪",
    mask: "##-###-###"
  },
  [a.Montserrat]: {
    id: a.Montserrat,
    name: "Montserrat",
    callingCode: "+1664",
    flagEmoji: "🇲🇸",
    mask: "###-####"
  },
  [a.Morocco]: {
    id: a.Morocco,
    name: "Morocco",
    callingCode: "+212",
    flagEmoji: "🇲🇦",
    mask: "##-####-###"
  },
  [a.Mozambique]: {
    id: a.Mozambique,
    name: "Mozambique",
    callingCode: "+258",
    flagEmoji: "🇲🇿",
    mask: "##-###-###"
  },
  [a.Myanmar]: {
    id: a.Myanmar,
    name: "Myanmar",
    callingCode: "+95",
    flagEmoji: "🇲🇲",
    mask: ["###-###", "#-###-###", "##-###-###"]
  },
  [a.Namibia]: {
    id: a.Namibia,
    name: "Namibia",
    callingCode: "+264",
    flagEmoji: "🇳🇦",
    mask: "##-###-####"
  },
  [a.Nauru]: {
    id: a.Nauru,
    name: "Nauru",
    callingCode: "+674",
    flagEmoji: "🇳🇷",
    mask: "###-####"
  },
  [a.Nepal]: {
    id: a.Nepal,
    name: "Nepal",
    callingCode: "+977",
    flagEmoji: "🇳🇵",
    mask: "##-###-###"
  },
  [a.Netherlands]: {
    id: a.Netherlands,
    name: "Netherlands",
    callingCode: "+31",
    flagEmoji: "🇳🇱",
    mask: "##-###-####"
  },
  [a.NetherlandsAntilles]: {
    id: a.NetherlandsAntilles,
    name: "Netherlands Antilles",
    callingCode: "+599",
    flagEmoji: "🇧🇶",
    mask: ["###-####", "9###-####"]
  },
  [a.NewCaledonia]: {
    id: a.NewCaledonia,
    name: "New Caledonia",
    callingCode: "+687",
    flagEmoji: "🇳🇨",
    mask: "##-####"
  },
  [a.NewZealand]: {
    id: a.NewZealand,
    name: "New Zealand",
    callingCode: "+64",
    flagEmoji: "🇳🇿",
    mask: ["#-###-###", "(###)###-###", "(###)###-####"]
  },
  [a.Nicaragua]: {
    id: a.Nicaragua,
    name: "Nicaragua",
    callingCode: "+505",
    flagEmoji: "🇳🇮",
    mask: "####-####"
  },
  [a.Niger]: {
    id: a.Niger,
    name: "Niger",
    callingCode: "+227",
    flagEmoji: "🇳🇪",
    mask: "##-##-####"
  },
  [a.Nigeria]: {
    id: a.Nigeria,
    name: "Nigeria",
    callingCode: "+234",
    flagEmoji: "🇳🇬",
    mask: ["##-###-##", "##-###-###", "(###)###-####"]
  },
  [a.Niue]: {
    id: a.Niue,
    name: "Niue",
    callingCode: "+683",
    flagEmoji: "🇳🇺",
    mask: "####"
  },
  [a.NorfolkIsland]: {
    id: a.NorfolkIsland,
    name: "Norfolk Island",
    callingCode: "+672",
    flagEmoji: "🇳🇫",
    mask: "1##-###"
  },
  [a.NorthernMarianaIslands]: {
    id: a.NorthernMarianaIslands,
    name: "Northern Mariana Islands",
    callingCode: "+1670",
    flagEmoji: "🇲🇵",
    mask: "###-####"
  },
  [a.Norway]: {
    id: a.Norway,
    name: "Norway",
    callingCode: "+47",
    flagEmoji: "🇳🇴",
    mask: "## ## ## ##"
  },
  [a.Oman]: {
    id: a.Oman,
    name: "Oman",
    callingCode: "+968",
    flagEmoji: "🇴🇲",
    mask: "##-###-###"
  },
  [a.Pakistan]: {
    id: a.Pakistan,
    name: "Pakistan",
    callingCode: "+92",
    flagEmoji: "🇵🇰",
    mask: "(###)###-####"
  },
  [a.Palau]: {
    id: a.Palau,
    name: "Palau",
    callingCode: "+680",
    flagEmoji: "🇵🇼",
    mask: "###-####"
  },
  [a.PalestinianTerritory]: {
    id: a.PalestinianTerritory,
    name: "Palestinian Territory, Occupied",
    callingCode: "+970",
    flagEmoji: "🇵🇸",
    mask: "##-###-####"
  },
  [a.Panama]: {
    id: a.Panama,
    name: "Panama",
    callingCode: "+507",
    flagEmoji: "🇵🇦",
    mask: "###-####"
  },
  [a.PapuaNewGuinea]: {
    id: a.PapuaNewGuinea,
    name: "Papua New Guinea",
    callingCode: "+675",
    flagEmoji: "🇵🇬",
    mask: "(###)##-###"
  },
  [a.Paraguay]: {
    id: a.Paraguay,
    name: "Paraguay",
    callingCode: "+595",
    flagEmoji: "🇵🇾",
    mask: "(###)###-###"
  },
  [a.Peru]: {
    id: a.Peru,
    name: "Peru",
    callingCode: "+51",
    flagEmoji: "🇵🇪",
    mask: "(###)###-###"
  },
  [a.Philippines]: {
    id: a.Philippines,
    name: "Philippines",
    callingCode: "+63",
    flagEmoji: "🇵🇭",
    mask: "(###)###-####"
  },
  [a.Pitcairn]: {
    id: a.Pitcairn,
    name: "Pitcairn",
    callingCode: "+87",
    flagEmoji: "🇵🇳",
    mask: "# ###-###-###"
  },
  [a.Poland]: {
    id: a.Poland,
    name: "Poland",
    callingCode: "+48",
    flagEmoji: "🇵🇱",
    mask: "(###)###-###"
  },
  [a.Portugal]: {
    id: a.Portugal,
    name: "Portugal",
    callingCode: "+351",
    flagEmoji: "🇵🇹",
    mask: "##-###-####"
  },
  [a.PuertoRico]: {
    id: a.PuertoRico,
    name: "Puerto Rico",
    callingCode: "+1939",
    flagEmoji: "🇵🇷",
    mask: "### ####"
  },
  [a.Qatar]: {
    id: a.Qatar,
    name: "Qatar",
    callingCode: "+974",
    flagEmoji: "🇶🇦",
    mask: "####-####"
  },
  [a.Romania]: {
    id: a.Romania,
    name: "Romania",
    callingCode: "+40",
    flagEmoji: "🇷🇴",
    mask: "##-###-####"
  },
  [a.Russia]: {
    id: a.Russia,
    name: "Russia",
    callingCode: "+7",
    flagEmoji: "🇷🇺",
    mask: "(###)###-##-##"
  },
  [a.Rwanda]: {
    id: a.Rwanda,
    name: "Rwanda",
    callingCode: "+250",
    flagEmoji: "🇷🇼",
    mask: "(###)###-###"
  },
  [a.Reunion]: {
    id: a.Reunion,
    name: "Reunion",
    callingCode: "+262",
    flagEmoji: "🇷🇪",
    mask: "#####-####"
  },
  [a.SaintBarthelemy]: {
    id: a.SaintBarthelemy,
    name: "Saint Barthelemy",
    callingCode: "+590",
    flagEmoji: "🇧🇱",
    mask: "(###)###-###"
  },
  [a.SaintHelena]: {
    id: a.SaintHelena,
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    callingCode: "+290",
    flagEmoji: "🇸🇭",
    mask: "####"
  },
  [a.SaintKittsAndNevis]: {
    id: a.SaintKittsAndNevis,
    name: "Saint Kitts and Nevis",
    callingCode: "+1869",
    flagEmoji: "🇰🇳",
    mask: "###-####"
  },
  [a.SaintLucia]: {
    id: a.SaintLucia,
    name: "Saint Lucia",
    callingCode: "+1758",
    flagEmoji: "🇱🇨",
    mask: "###-####"
  },
  [a.SaintMartin]: {
    id: a.SaintMartin,
    name: "Saint Martin",
    callingCode: "+590",
    flagEmoji: "🇲🇫",
    mask: "(###)###-###"
  },
  [a.SaintPierreAndMiquelon]: {
    id: a.SaintPierreAndMiquelon,
    name: "Saint Pierre and Miquelon",
    callingCode: "+508",
    flagEmoji: "🇵🇲",
    mask: "##-####"
  },
  [a.SaintVincentAndTheGrenadines]: {
    id: a.SaintVincentAndTheGrenadines,
    name: "Saint Vincent and the Grenadines",
    callingCode: "+1784",
    flagEmoji: "🇻🇨",
    mask: "###-####"
  },
  [a.Samoa]: {
    id: a.Samoa,
    name: "Samoa",
    callingCode: "+685",
    flagEmoji: "🇼🇸",
    mask: "##-####"
  },
  [a.SanMarino]: {
    id: a.SanMarino,
    name: "San Marino",
    callingCode: "+378",
    flagEmoji: "🇸🇲",
    mask: "####-######"
  },
  [a.SaoTomeAndPrincipe]: {
    id: a.SaoTomeAndPrincipe,
    name: "Sao Tome and Principe",
    callingCode: "+239",
    flagEmoji: "🇸🇹",
    mask: "##-#####"
  },
  [a.SaudiArabia]: {
    id: a.SaudiArabia,
    name: "Saudi Arabia",
    callingCode: "+966",
    flagEmoji: "🇸🇦",
    mask: ["#-###-####", "5#-####-####"]
  },
  [a.Senegal]: {
    id: a.Senegal,
    name: "Senegal",
    callingCode: "+221",
    flagEmoji: "🇸🇳",
    mask: "##-###-####"
  },
  [a.Serbia]: {
    id: a.Serbia,
    name: "Serbia",
    callingCode: "+381",
    flagEmoji: "🇷🇸",
    mask: "##-###-####"
  },
  [a.Seychelles]: {
    id: a.Seychelles,
    name: "Seychelles",
    callingCode: "+248",
    flagEmoji: "🇸🇨",
    mask: "#-###-###"
  },
  [a.SierraLeone]: {
    id: a.SierraLeone,
    name: "Sierra Leone",
    callingCode: "+232",
    flagEmoji: "🇸🇱",
    mask: "##-######"
  },
  [a.Singapore]: {
    id: a.Singapore,
    name: "Singapore",
    callingCode: "+65",
    flagEmoji: "🇸🇬",
    mask: "####-####"
  },
  [a.Slovakia]: {
    id: a.Slovakia,
    name: "Slovakia",
    callingCode: "+421",
    flagEmoji: "🇸🇰",
    mask: "(###)###-###"
  },
  [a.Slovenia]: {
    id: a.Slovenia,
    name: "Slovenia",
    callingCode: "+386",
    flagEmoji: "🇸🇮",
    mask: "##-###-###"
  },
  [a.SolomonIslands]: {
    id: a.SolomonIslands,
    name: "Solomon Islands",
    callingCode: "+677",
    flagEmoji: "🇸🇧",
    mask: ["#####", "###-####"]
  },
  [a.Somalia]: {
    id: a.Somalia,
    name: "Somalia",
    callingCode: "+252",
    flagEmoji: "🇸🇴",
    mask: ["#-###-###", "##-###-###"]
  },
  [a.SouthAfrica]: {
    id: a.SouthAfrica,
    name: "South Africa",
    callingCode: "+27",
    flagEmoji: "🇿🇦",
    mask: "##-###-####"
  },
  [a.SouthSudan]: {
    id: a.SouthSudan,
    name: "South Sudan",
    callingCode: "+211",
    flagEmoji: "🇸🇸",
    mask: "##-###-####"
  },
  [a.SouthGeorgiaAndTheSouthSandwichIslands]: {
    id: a.SouthGeorgiaAndTheSouthSandwichIslands,
    name: "South Georgia and the South Sandwich Islands",
    callingCode: "+500",
    flagEmoji: "🇬🇸",
    mask: "#####"
  },
  [a.Spain]: {
    id: a.Spain,
    name: "Spain",
    callingCode: "+34",
    flagEmoji: "🇪🇸",
    mask: "(###)###-###"
  },
  [a.SriLanka]: {
    id: a.SriLanka,
    name: "Sri Lanka",
    callingCode: "+94",
    flagEmoji: "🇱🇰",
    mask: "##-###-####"
  },
  [a.Sudan]: {
    id: a.Sudan,
    name: "Sudan",
    callingCode: "+249",
    flagEmoji: "🇸🇩",
    mask: "##-###-####"
  },
  [a.Suriname]: {
    id: a.Suriname,
    name: "Suriname",
    callingCode: "+597",
    flagEmoji: "🇸🇷",
    mask: ["###-###", "###-####"]
  },
  [a.SvalbardAndJanMayen]: {
    id: a.SvalbardAndJanMayen,
    name: "Svalbard and Jan Mayen",
    callingCode: "+47",
    flagEmoji: "🇸🇯",
    mask: "(###)##-###"
  },
  [a.Swaziland]: {
    id: a.Swaziland,
    name: "Swaziland",
    callingCode: "+268",
    flagEmoji: "🇸🇿",
    mask: "##-##-####"
  },
  [a.Sweden]: {
    id: a.Sweden,
    name: "Sweden",
    callingCode: "+46",
    flagEmoji: "🇸🇪",
    mask: "##-###-####"
  },
  [a.Switzerland]: {
    id: a.Switzerland,
    name: "Switzerland",
    callingCode: "+41",
    flagEmoji: "🇨🇭",
    mask: "##-###-####"
  },
  [a.Syria]: {
    id: a.Syria,
    name: "Syrian Arab Republic",
    callingCode: "+963",
    flagEmoji: "🇸🇾",
    mask: "##-####-###"
  },
  [a.Taiwan]: {
    id: a.Taiwan,
    name: "Taiwan",
    callingCode: "+886",
    flagEmoji: "🇹🇼",
    mask: ["####-####", "#-####-####"]
  },
  [a.Tajikistan]: {
    id: a.Tajikistan,
    name: "Tajikistan",
    callingCode: "+992",
    flagEmoji: "🇹🇯",
    mask: "##-###-####"
  },
  [a.Tanzania]: {
    id: a.Tanzania,
    name: "Tanzania, United Republic of Tanzania",
    callingCode: "+255",
    flagEmoji: "🇹🇿",
    mask: "##-###-####"
  },
  [a.Thailand]: {
    id: a.Thailand,
    name: "Thailand",
    callingCode: "+66",
    flagEmoji: "🇹🇭",
    mask: ["##-###-###", "##-###-####"]
  },
  [a.TimorLeste]: {
    id: a.TimorLeste,
    name: "Timor-Leste",
    callingCode: "+670",
    flagEmoji: "🇹🇱",
    mask: ["###-####", "77#-#####", "78#-#####"]
  },
  [a.Togo]: {
    id: a.Togo,
    name: "Togo",
    callingCode: "+228",
    flagEmoji: "🇹🇬",
    mask: "##-###-###"
  },
  [a.Tokelau]: {
    id: a.Tokelau,
    name: "Tokelau",
    callingCode: "+690",
    flagEmoji: "🇹🇰",
    mask: "####"
  },
  [a.Tonga]: {
    id: a.Tonga,
    name: "Tonga",
    callingCode: "+676",
    flagEmoji: "🇹🇴",
    mask: "#####"
  },
  [a.TrinidadAndTobago]: {
    id: a.TrinidadAndTobago,
    name: "Trinidad and Tobago",
    callingCode: "+1868",
    flagEmoji: "🇹🇹",
    mask: "###-####"
  },
  [a.Tunisia]: {
    id: a.Tunisia,
    name: "Tunisia",
    callingCode: "+216",
    flagEmoji: "🇹🇳",
    mask: "##-###-###"
  },
  [a.Turkey]: {
    id: a.Turkey,
    name: "Turkey",
    callingCode: "+90",
    flagEmoji: "🇹🇷",
    mask: "(###)###-####"
  },
  [a.Turkmenistan]: {
    id: a.Turkmenistan,
    name: "Turkmenistan",
    callingCode: "+993",
    flagEmoji: "🇹🇲",
    mask: "#-###-####"
  },
  [a.TurksAndCaicosIslands]: {
    id: a.TurksAndCaicosIslands,
    name: "Turks and Caicos Islands",
    callingCode: "+1649",
    flagEmoji: "🇹🇨",
    mask: "###-####"
  },
  [a.Tuvalu]: {
    id: a.Tuvalu,
    name: "Tuvalu",
    callingCode: "+688",
    flagEmoji: "🇹🇻",
    mask: ["2####", "90####"]
  },
  [a.Uganda]: {
    id: a.Uganda,
    name: "Uganda",
    callingCode: "+256",
    flagEmoji: "🇺🇬",
    mask: "(###)###-###"
  },
  [a.Ukraine]: {
    id: a.Ukraine,
    name: "Ukraine",
    callingCode: "+380",
    flagEmoji: "🇺🇦",
    mask: "(##)###-##-##"
  },
  [a.UnitedArabEmirates]: {
    id: a.UnitedArabEmirates,
    name: "United Arab Emirates",
    callingCode: "+971",
    flagEmoji: "🇦🇪",
    mask: ["#-###-####", "5#-###-####"]
  },
  [a.UnitedKingdom]: {
    id: a.UnitedKingdom,
    name: "United Kingdom",
    callingCode: "+44",
    flagEmoji: "🇬🇧",
    mask: "(####)######"
  },
  [a.UnitedStates]: {
    id: a.UnitedStates,
    name: "United States",
    callingCode: "+1",
    flagEmoji: "🇺🇸",
    mask: "(684)###-####"
  },
  [a.Canada]: {
    id: a.Canada,
    name: "Canada",
    callingCode: "+1",
    flagEmoji: "🇨🇦",
    mask: "(684)###-####"
  },
  [a.Uruguay]: {
    id: a.Uruguay,
    name: "Uruguay",
    callingCode: "+598",
    flagEmoji: "🇺🇾",
    mask: "#-###-##-##"
  },
  [a.Uzbekistan]: {
    id: a.Uzbekistan,
    name: "Uzbekistan",
    callingCode: "+998",
    flagEmoji: "🇺🇿",
    mask: "##-###-####"
  },
  [a.Vanuatu]: {
    id: a.Vanuatu,
    name: "Vanuatu",
    callingCode: "+678",
    flagEmoji: "🇻🇺",
    mask: ["#####", "##-#####"]
  },
  [a.Venezuela]: {
    id: a.Venezuela,
    name: "Venezuela, Bolivarian Republic of Venezuela",
    callingCode: "+58",
    flagEmoji: "🇻🇪",
    mask: "(###)###-####"
  },
  [a.Vietnam]: {
    id: a.Vietnam,
    name: "Vietnam",
    callingCode: "+84",
    flagEmoji: "🇻🇳",
    mask: ["##-####-###", "(###)####-###"]
  },
  [a.BritishVirginIslands]: {
    id: a.BritishVirginIslands,
    name: "Virgin Islands, British",
    callingCode: "+1284",
    flagEmoji: "🇻🇬",
    mask: "###-####"
  },
  [a.VirginIslands]: {
    id: a.VirginIslands,
    name: "Virgin Islands, U.S.",
    callingCode: "+1340",
    flagEmoji: "🇻🇮",
    mask: "###-####"
  },
  [a.WallisAndFutuna]: {
    id: a.WallisAndFutuna,
    name: "Wallis and Futuna",
    callingCode: "+681",
    flagEmoji: "🇼🇫",
    mask: "##-####"
  },
  [a.Yemen]: {
    id: a.Yemen,
    name: "Yemen",
    callingCode: "+967",
    flagEmoji: "🇾🇪",
    mask: ["#-###-###", "##-###-###", "###-###-###"]
  },
  [a.Zambia]: {
    id: a.Zambia,
    name: "Zambia",
    callingCode: "+260",
    flagEmoji: "🇿🇲",
    mask: "##-###-####"
  },
  [a.Zimbabwe]: {
    id: a.Zimbabwe,
    name: "Zimbabwe",
    callingCode: "+263",
    flagEmoji: "🇿🇼",
    mask: "#-######"
  }
}, Oi = f.input`
  width: 100%;
  height: 2.5rem;
  padding: 0 var(--p-spacing-08);
  border: none;
  box-sizing: border-box;
  font-family: 'Storebrand Text', sans-serif;
  font-size: 1.125rem;
  color: var(--p-color-red-800);
  line-height: inherit;
  caret-color: var(--color-on-background);
  background: none;
  outline: none;
  /* hide arrows on input type number start*/
  /* Chrome, Safari */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  /* clears the ‘X’ from Internet Explorer */
  &[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  &[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  /* clears the ‘X’ from Chrome */
  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  &:disabled {
    cursor: not-allowed;
    caret-color: var(--p-color-background-disabled-grey);
    color: var(--p-color-background-disabled-grey);
  }
`, Te = f.div`
  --background-color: var(--p-color-background);

  width: auto;
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  border: 1px solid var(--p-color-stroke-0);
  border-radius: var(--p-corner-radius-small);
  background: var(--background-color);
  cursor: text;

  &:focus-within {
    border: 0.0938rem solid var(--p-color-stroke-strong);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      --background-color: var(--p-color-background-hover);
    }
  }

  &:has(:disabled) {
    pointer-events: none;
  }

  ${({ $disabled: e }) => e && g`
      color: var(--p-color-background-disabled-grey);
      border: 1px solid var(--p-color-background-disabled-grey);
      cursor: not-allowed;
    `}

  ${({ $medium: e, $large: n, $fluid: o }) => e ? g`
        width: 100%;
        max-width: 288px;
      ` : n ? g`
        width: 100%;
        max-width: 528px;
      ` : o ? g`
        width: 100%;
      ` : g`
      max-width: 100%;
    `}

  ${({ $readOnly: e }) => e && g`
      &:focus-within {
        outline: none;
      }
    `}

  ${({ $success: e, $warning: n, $error: o }) => e ? g`
        outline: 2px solid var(--p-color-icon-successt);
        border-color: var(--p-color-icon-success);
      ` : n ? g`
        outline: 2px solid var(--color-warning-accent);
        border-color: var(--color-warning-accent);
      ` : o ? g`
        outline: 2x solid var(--p-color-stroke-error);
        border-color: var(--p-color-stroke-error);
      ` : ""}
`, zi = f.div.attrs({
  className: "autosuggest"
})`
  display: inline-flex;
  flex-direction: column;
  width: 100%;

  color: var(--color-on-background);
  font-family: 'Storebrand Text', sans-serif;
  font-size: 1.25rem;
  line-height: 1.2;
  color: var(--p-color-red-800);

  &[aria-disabled='true'] {
    color: var(--p-color-background-disabled-grey);
  }

  ${({ $fluid: e }) => e && g`
      width: 100%;
      max-width: 100%;

      & > ${Te} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }

  &,
  & * {
    box-sizing: border-box;
  }
`, Pe = f(_a)``, Ki = f.button.attrs({ type: "button" })`
  border: 0;
  padding: 0 var(--p-spacing-08);
  background: none;
  margin: 0;
  cursor: pointer;
  appearance: none;
  display: grid;
  place-items: center;
  grid-template-columns: auto 1fr;
  font-family: 'Storebrand Text', sans-serif;
  font-size: 1.25rem;
  line-height: 1;
  color: var(--p-color-red-800);

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      background-color: var(--color-overlay-hover-darken);
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--p-color-gray-500);
  }

  ${Pe} {
    text-align: left;
    margin-left: var(--p-spacing-04);
  }
`, Sa = {
  SystemIcon: Pe,
  Container: Te,
  NativeInput: Oi,
  Base: zi,
  CountrySelectButton: Ki
};
function Hi(e) {
  return (e == null ? void 0 : e.replace(yi, "")) ?? "";
}
function Ui(e) {
  return function(o) {
    const t = [...e].sort(
      (h, p) => h.callingCode.length - p.callingCode.length
    ), c = Hi(o), u = t.find(
      ({ callingCode: h }) => c.startsWith(h) || c.startsWith(h.replace("+", "00"))
    );
    return {
      country: u,
      internationalPhoneNumber: c,
      localPhoneNumber: (() => {
        var h;
        if (u) {
          const p = new RegExp(
            `(?:\\+|00)${u.callingCode.replace("+", "")}`
          ), R = (h = c.match(p)) == null ? void 0 : h[0];
          return c.substring(
            (R == null ? void 0 : R.length) ?? 0,
            c.length
          );
        }
        return "";
      })()
    };
  };
}
const Wn = X(
  ({
    countries: e,
    countryDropdownLabel: n,
    disabled: o,
    messageType: t,
    message: c,
    hint: u,
    id: b,
    label: h,
    name: p,
    preferredCountries: R,
    readOnly: S,
    value: d,
    onBlur: I,
    onChange: E,
    size: v,
    trackid: G,
    defaultCountryCode: F = a.Norway,
    ...B
  }, j) => {
    var oa;
    const y = `${b}-phone-input`, J = `${b}-phone-input-label`, $ = `${b}-phone-input-dropdown`, M = Fa(), q = ga(!1), H = da(
      () => Object.entries(xa).filter(
        ([A]) => e ? e.includes(A) : !0
      ).map(([, A]) => A),
      [e]
    ), z = Ui(H), ya = xa[F], [Oa, fa] = Ba(!1), W = d != null && d.internationalPhoneNumber ? d.internationalPhoneNumber : ya.callingCode, {
      country: O = d != null && d.internationalPhoneNumber ? (oa = z(d.internationalPhoneNumber).country) == null ? void 0 : oa.id : F
    } = d ?? {}, U = ga(null);
    ai(
      j,
      () => U.current
    );
    const [Ia, pa] = Ba(), {
      value: Z,
      on: ha,
      off: Aa
    } = oi();
    function aa() {
      pa(void 0), Aa();
    }
    function Ta(A) {
      var ia;
      fa(!0);
      const P = xa[A], V = z(d == null ? void 0 : d.internationalPhoneNumber), ea = `${P.callingCode}${V.localPhoneNumber}`;
      E == null || E({
        ...V,
        internationalPhoneNumber: ea,
        country: A
      }), aa(), (ia = U.current) == null || ia.focus();
    }
    function Pa(A) {
      var V;
      fa(!0);
      const P = z(A.target.value);
      E == null || E({
        localPhoneNumber: P.localPhoneNumber,
        country: (V = P.country) == null ? void 0 : V.id,
        internationalPhoneNumber: P.internationalPhoneNumber
      });
    }
    function za() {
      var A;
      Z ? aa() : ha(), (A = U.current) == null || A.focus();
    }
    function Ka({
      key: A
    }) {
      var P;
      ["ArrowUp", "ArrowDown"].includes(A) && !Z && ((P = U.current) != null && P.contains(document.activeElement)) && ha();
    }
    function ba(A) {
      aa(), I == null || I(A);
    }
    return La(() => {
      var A;
      if (!q.current && (d != null && d.internationalPhoneNumber)) {
        const P = z(d.internationalPhoneNumber);
        E == null || E({
          localPhoneNumber: P.localPhoneNumber,
          country: (A = P.country) == null ? void 0 : A.id,
          internationalPhoneNumber: P.internationalPhoneNumber
        }), q.current = !0;
      }
    }, [d, z, E]), /* @__PURE__ */ l.jsxs(Sa.Base, { ...B, children: [
      /* @__PURE__ */ l.jsx(li, { id: J, htmlFor: b, title: h, hint: u }),
      /* @__PURE__ */ l.jsx(ua, { size: "08" }),
      /* @__PURE__ */ l.jsxs(
        Sa.Container,
        {
          $disabled: o,
          $readOnly: S,
          $medium: v === "medium",
          $large: v === "large",
          $fluid: v === "fluid",
          $success: t === "success",
          $warning: t === "warning",
          $error: t === "error",
          children: [
            /* @__PURE__ */ l.jsxs(
              Sa.CountrySelectButton,
              {
                "aria-hidden": !0,
                onClick: za,
                onMouseDown: (A) => A.preventDefault(),
                tabIndex: -1,
                disabled: o,
                children: [
                  O ? xa[O].flagEmoji : Di,
                  /* @__PURE__ */ l.jsx(Sa.SystemIcon, { name: "arrow-drop-down", size: 12 })
                ]
              }
            ),
            /* @__PURE__ */ l.jsx(
              Sa.NativeInput,
              {
                "aria-activedescendant": Ia,
                "aria-autocomplete": "none",
                "aria-controls": Z ? $ : void 0,
                "aria-expanded": Z,
                "aria-invalid": t === "error",
                autoComplete: Z ? "off" : "tel",
                "data-trackid": G,
                disabled: o,
                id: y,
                name: p,
                onBlur: ba,
                onChange: Pa,
                onKeyDown: Ka,
                onBeforeInput: (A) => {
                  const P = A.currentTarget;
                  if (P.value.trim().length === 0) {
                    const ea = P.selectionStart ?? 0, ia = P.selectionEnd ?? 0, Ea = (O && xa[O].callingCode) ?? "";
                    P.value = `${P.value.substring(0, ea)}${Ea}${P.value.substring(ia)}`, P.setSelectionRange(
                      ea + Ea.length + 1,
                      ea + Ea.length + 1
                    );
                  }
                },
                readOnly: S,
                ref: U,
                role: "combobox",
                value: Oa ? (d == null ? void 0 : d.internationalPhoneNumber) ?? "" : W,
                "aria-describedby": M
              }
            ),
            Z && /* @__PURE__ */ l.jsx(
              _i,
              {
                countries: H,
                id: $,
                label: n,
                onActiveDescendantChange: pa,
                onClose: aa,
                onCountrySelect: Ta,
                preferredCountries: R,
                value: O
              }
            )
          ]
        }
      ),
      t && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(ua, { size: "08" }),
        /* @__PURE__ */ l.jsx(Qa, { variant: t, title: c, id: M })
      ] })
    ] });
  }
), Vi = f.div`
  --foundation-selection-card-border: 0 0 0 1px inset var(--p-color-grey-300);
  --foundation-selection-card-border-disabled: 0 0 0 1px inset
    var(--color-disabled-variant);
  --foundation-selection-card-border-error: 0 0 0 2px inset
    var(--p-color-stroke-error);
  --foundation-selection-card-border-selected: 0 0 0 2px inset
    var(--p-color-red-800);
  --color-disabled: rgb(119 0 0 / 60%);

  // Whole value is exposed as --outline in Storeblocks, but we just need the colour
  --foundation-selection-card-outline:
    var(--p-color-text-interactive) 0 0 0 2px, var(--p-color-red-800) 0 0 0 4px;

  --foundation-card-padding: ${({ size: e }) => {
  switch (e) {
    case "small":
      return g`var(--p-spacing-16)`;
    case "medium":
      return g`var(--p-spacing-24) var(--p-spacing-20)`;
    default:
      return g`var(--p-spacing-32)`;
  }
}};

  --foundation-card-padding-mobile: ${({ size: e }) => {
  switch (e) {
    case "small":
      return g`var(--p-spacing-16)`;
    case "medium":
      return g`var(--p-spacing-20) var(--p-spacing-16)`;
    default:
      return g`var(--p-spacing-24) var(--p-spacing-20)`;
  }
}};

  --foundation-card-gap: ${({ size: e }) => {
  switch (e) {
    case "small":
      return g`var(--p-spacing-20)`;
    case "medium":
      return g`var(--p-spacing-20)`;
    default:
      return g`var(--p-spacing-24)`;
  }
}};

  --foundation-card-gap-mobile: ${({ size: e }) => {
  switch (e) {
    case "small":
      return g`var(--p-spacing-16)`;
    case "medium":
      return g`var(--p-spacing-16)`;
    default:
      return g`var(--p-spacing-20)`;
  }
}};

  align-items: center;
  border-radius: var(--p-corner-radius-small);
  box-shadow: var(--foundation-selection-card-border);
  cursor: pointer;
  display: grid;
  gap: 0 var(--foundation-card-gap);
  grid-template-columns:
    [indicator] var(--foundation-card-gap)
    [text] auto
    ${({ $hasFigure: e }) => e && g`[figure] fit-content(50px)`};
  padding: var(--foundation-card-padding);
  user-select: none;

  @media only screen and (max-width: ${Y.S}) {
    padding: var(--foundation-card-padding-mobile);
    grid-template-columns:
      [indicator] var(--foundation-card-gap-mobile)
      [text] auto
      ${({ $hasFigure: e }) => e && g`[figure] fit-content(50px)`};
  }

  &:has(:focus-visible) {
    box-shadow:
      var(--foundation-selection-card-border),
      var(--foundation-selection-card-outline);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: var(--p-color-background-hover-grey);
    }
  }

  ${({ $isSelected: e, $isDisabled: n, $hasError: o }) => {
  if (n)
    return g`
        pointer-events: none;
        color: var(--p-color-grey-400);
        box-shadow: var(--foundation-selection-card-border);
        cursor: not-allowed;
        background: var(--p-color-background-grey);

        &:has(:focus-visible) {
          box-shadow:
            var(--foundation-selection-card-border),
            var(--foundation-selection-card-outline);
        }

        label,
        p {
          color: var(--p-color-grey-400);
        }

        @media (hover: hover) and (pointer: fine) {
          &:hover {
            background: var(--p-color-background-grey);
          }
        }

        * {
          color: var(--p-color-grey-400);
        }
      `;
  if (o)
    return g`
        box-shadow: var(--foundation-selection-card-border-error);
        background: var(--p-color-red-100);

        &:has(:focus-visible) {
          box-shadow:
            var(--foundation-selection-card-border-error),
            var(--foundation-selection-card-outline);
        }
      `;
  if (e)
    return g`
        background: var(--p-color-background-grey);
        box-shadow: var(--foundation-selection-card-border-selected);

        &:has(:focus-visible) {
          box-shadow:
            var(--foundation-selection-card-border-selected),
            var(--foundation-selection-card-outline);
        }
      `;
}}
`, Wi = f.span`
  grid-area: indicator;
  i {
    display: block;
  }
`, Yi = f.span`
  grid-area: text;
  place-self: center start;
  display: grid;
`, Ji = f.span`
  grid-area: figure;
`, qi = f.input`
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
`, Zi = f.label`
  cursor: inherit;
`, ca = { Text: Yi, Wrapper: Vi, HiddenInput: qi, Figure: Ji, IconWrapper: Wi, Label: Zi }, Xi = {
  selected: "check-circle-filled",
  unselected: "radio-unselected"
}, Qi = {
  checked: "selection-controls-checked",
  unchecked: "selection-controls-unchecked"
}, Ci = X(
  ({
    checked: e,
    description: n,
    disabled: o,
    figure: t,
    hasError: c,
    label: u,
    onBlur: b,
    onChange: h,
    onClick: p,
    onFocus: R,
    trackId: S,
    type: d = "radio",
    value: I,
    size: E = "large",
    "aria-labelledby": v,
    "aria-describedby": G,
    readOnly: F
  }, B) => {
    const j = ga(null), y = ga(null), J = Fa(), $ = Fa();
    return /* @__PURE__ */ l.jsxs(
      ca.Wrapper,
      {
        $hasError: c,
        $isDisabled: o,
        $isSelected: e,
        $hasFigure: !!t,
        size: E,
        onClick: (M) => {
          var q, H;
          (q = y.current) != null && q.contains(M.target) || (H = j.current) == null || H.click();
        },
        children: [
          /* @__PURE__ */ l.jsx(
            ca.HiddenInput,
            {
              id: $,
              checked: e,
              "data-trackid": S,
              "aria-disabled": o,
              onBlur: b,
              onChange: (M) => {
                o ? M.preventDefault() : h == null || h(M);
              },
              onClick: p,
              onFocus: R,
              ref: ti(B, j),
              type: d,
              value: I,
              "aria-describedby": [J, G].filter(Boolean).join(" "),
              "aria-labelledby": v,
              readOnly: F
            }
          ),
          /* @__PURE__ */ l.jsx(ca.IconWrapper, { children: d === "radio" ? /* @__PURE__ */ l.jsx(
            _a,
            {
              name: Xi[e ? "selected" : "unselected"],
              size: 22
            }
          ) : /* @__PURE__ */ l.jsx(
            _a,
            {
              name: Qi[e ? "checked" : "unchecked"],
              size: 24
            }
          ) }),
          /* @__PURE__ */ l.jsxs(ca.Text, { children: [
            u && /* @__PURE__ */ l.jsx(
              ca.Label,
              {
                className: "font-heading-4",
                htmlFor: $,
                ref: y,
                children: u
              }
            ),
            n && /* @__PURE__ */ l.jsx("span", { id: J, children: n })
          ] }),
          t && /* @__PURE__ */ l.jsx(ca.Figure, { children: t })
        ]
      }
    );
  }
);
function Yn(e) {
  const { as: n = "span", html: o, ...t } = e;
  return /* @__PURE__ */ l.jsx(
    n,
    {
      ...t,
      dangerouslySetInnerHTML: {
        __html: si.sanitize(o)
      }
    }
  );
}
const an = f(Ie)`
  margin-bottom: 0;

  @media only screen and (max-width: ${Da.L}) {
    margin-bottom: var(--p-spacing-96);
  }

  @media only screen and (max-width: ${Da.M}) {
    margin-bottom: var(--p-spacing-64);
  }

  & > *:nth-child(n + 2) {
    margin-top: var(--p-spacing-24);
  }
`, en = f.div`
  align-items: center;
  background: var(--p-color-background);
  border-top: 1px solid var(--p-color-grey-200);
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 2;
  height: 64px;

  @media only screen and (min-width: ${Y.S}) {
    height: 80px;
  }

  @media only screen and (min-width: ${Y.M}) {
    height: 94px;
  }

  @media only screen and (min-width: ${Y.L}) {
    position: relative;
    background: transparent;
    border: 0;
  }
`, ve = { Container: an, BottomBar: en }, Jn = X(
  ({ header: e, body: n, footer: o, ...t }, c) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    (n ?? e) && /* @__PURE__ */ l.jsxs(ve.Container, { ...t, ref: c, children: [
      e && /* @__PURE__ */ l.jsx("div", { children: e }),
      n && /* @__PURE__ */ l.jsx("div", { children: n })
    ] }),
    o && /* @__PURE__ */ l.jsx(ve.BottomBar, { children: /* @__PURE__ */ l.jsx(Ie, { children: o }) })
  ] })
), ae = "var(--p-color-red-100)", Ra = "var(--p-color-red-800)";
var la = /* @__PURE__ */ ((e) => (e.disabledLight = "#e9e2e2", e.disabledNormal = "#b6a5a5", e))(la || {}), ra = /* @__PURE__ */ ((e) => (e.right = "16px", e.left = "12px", e.topAndBottom = "6px", e))(ra || {});
const ke = "1px", Za = "1px";
function nn(e, n = !1) {
  return e === "checked" ? n ? la.disabledLight : Ra : "transparent";
}
function rn(e, n = !1) {
  return n ? la.disabledNormal : e === "checked" ? ae : Ra;
}
function ln(e, n = !1) {
  return e === "checked" ? "transparent" : e === "unchecked" ? n ? la.disabledNormal : Ra : e === "error" ? "var(--p-color-stroke-error)" : "transparent";
}
function on(e, n = !1) {
  return e === "checked" ? n ? la.disabledNormal : ae : "transparent";
}
function tn(e, n = !1) {
  return e === "checked" ? n ? la.disabledNormal : ae : e === "unchecked" ? n ? la.disabledNormal : Ra : e === "error" ? Ra : "transparent";
}
const sn = f.fieldset`
  border: none;
  padding: 0;
`, cn = f.div`
  display: flex;
  flex-flow: row wrap;
  gap: var(--p-spacing-08);
  ${({ $maxPillGroupWidth: e }) => e && g`
      max-width: ${e};
    `}
`;
f.legend`
  font-weight: 600;
`;
const dn = f.label`
  display: flex;
  align-items: center;
  flex: 1;
  gap: var(--p-spacing-08);
  padding: ${ra.topAndBottom} ${ra.right}
    ${ra.topAndBottom} ${ra.left};
  height: 40px;
  box-sizing: border-box;
  border: ${ke} solid transparent;
  border-radius: var(--p-border-radius-06, 48px);
  font-weight: 500;
  cursor: pointer;
  user-select: none;

  ${({ $radioState: e, $disabled: n }) => g`
    background-color: ${nn(e, n)};
    color: ${rn(e, n)};
    border-color: ${ln(e, n)};

    input {
      border-color: ${tn(e, n)};

      &:before {
        background: ${on(e, n)};
      }
    }
  `}
  ${({ $radioState: e }) => e === "error" && g`
      border-width: calc(${ke} + ${Za});
      padding-right: calc(${ra.right} - ${Za});
      padding-left: calc(${ra.left} - ${Za});
    `}
    ${({ $disabled: e }) => e && g`
      cursor: not-allowed;
    `}
    ${({ $disabled: e }) => !e && g`
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background-color: var(--p-color-red-700);
          color: var(--p-color-red-100);
          border-color: transparent;

          input {
            border-color: var(--p-color-red-100);
          }
        }
      }
    `}
    &:has(input:focus-visible) {
    outline-offset: 4px;
    outline: 5px auto black; /* Firefox */
    outline: 5px auto -webkit-focus-ring-color;
  }
`, mn = f.input`
  appearance: none;
  height: 20px;
  width: 20px;
  border: 1px solid var(--p-color-red-800);
  border-radius: 50%;
  outline: none;
  pointer-events: none;

  &:before {
    content: '';
    display: block;
    width: 70%;
    height: 70%;
    margin: 15%;
    border-radius: 50%;
    transition: ease-out 0.075s;
  }
`, $a = { Fieldset: sn, BooleanPills: cn, BooleanPill: dn, RadioIndicator: mn };
function gn(e, n, o) {
  return o ? "error" : String(n) === e ? "checked" : "unchecked";
}
const un = (e) => e ? typeof e.text < "u" : !1;
function qn({
  legend: e,
  value: n,
  onValueChange: o,
  trueLabel: t,
  falseLabel: c,
  maxPillGroupWidth: u = "180px",
  id: b,
  error: h,
  disabled: p,
  "aria-labelledby": R,
  ...S
}) {
  const d = [
    { pillValue: "true", label: t },
    { pillValue: "false", label: c }
  ];
  function I({ target: { value: G } }) {
    o(G === "true");
  }
  const E = Fa(), v = b ?? E;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(
      $a.Fieldset,
      {
        "aria-disabled": p ?? !!(h != null && h.length),
        "aria-labelledby": R,
        ...S,
        children: [
          un(e) ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
            /* @__PURE__ */ l.jsx(we, { title: e.text, hint: e.hint }),
            /* @__PURE__ */ l.jsx(ua, { size: "16" })
          ] }) : e,
          /* @__PURE__ */ l.jsx($a.BooleanPills, { $maxPillGroupWidth: u, children: d.map(({ pillValue: G, label: F }) => /* @__PURE__ */ l.jsxs(
            $a.BooleanPill,
            {
              $radioState: gn(
                G,
                n,
                h
              ),
              $disabled: p,
              children: [
                /* @__PURE__ */ l.jsx(
                  $a.RadioIndicator,
                  {
                    type: "radio",
                    name: v,
                    value: G,
                    checked: String(n ?? "") === G,
                    onChange: I
                  }
                ),
                /* @__PURE__ */ l.jsx("span", { children: F })
              ]
            },
            G
          )) })
        ]
      }
    ),
    h && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(ua, { size: "08" }),
      /* @__PURE__ */ l.jsx(Qa, { title: h, variant: "error" })
    ] })
  ] });
}
class Zn extends ei {
  constructor(n) {
    super(n), this.state = { hasError: !1, error: void 0 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(n, o) {
    const { logger: t } = this.props;
    if (this.setState({ error: n }), !t) {
      console.error(n, o);
      return;
    }
    t(n, o);
  }
  render() {
    const { hasError: n, error: o } = this.state, { children: t, errorView: c } = this.props, u = typeof c == "function" && o && c(o);
    return n ? /* @__PURE__ */ l.jsxs("div", { children: [
      typeof c != "function" ? c : u,
      !c && /* @__PURE__ */ l.jsxs(ci, { title: "Error", className: "subtitle", variant: "error", children: [
        "Error: ",
        o == null ? void 0 : o.message
      ] })
    ] }) : /* @__PURE__ */ l.jsx(l.Fragment, { children: t });
  }
}
const fn = f(Ae)`
  // Optical adjustment since Sigma font's baseline is not centered
  margin: 5px 0 0 0;
`, Me = f.div`
  flex: 1 0 auto;
  max-width: 64px;
  text-align: right;

  @media only screen and (max-width: ${Da.S}) {
    max-width: 56px;
  }

  svg,
  img {
    width: 100%;
  }
`, pn = f.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--p-spacing-32);

  ${({ $isReverseOrder: e }) => e && g`
      flex-direction: row-reverse;
      ${Me} {
        text-align: left;
      }
    `}
`, Xa = { Row: pn, Heading: fn, Figure: Me }, Xn = X(
  ({
    headingHtmlTag: e = "h1",
    styleAs: n = e,
    heading: o,
    figure: t,
    isReverseOrder: c,
    ...u
  }, b) => /* @__PURE__ */ l.jsxs(Xa.Row, { ...u, $isReverseOrder: c, ref: b, children: [
    /* @__PURE__ */ l.jsx(Xa.Heading, { htmlTag: e, styleAs: n, children: o }),
    t && /* @__PURE__ */ l.jsx(Xa.Figure, { children: t })
  ] })
), hn = f.div`
  display: flex;
  align-items: center;
  gap: var(--p-spacing-24);
  justify-content: space-between;
`, bn = f.div`
  width: 100%;

  .loadingIndicatorContainer {
    min-width: auto;
  }
`, je = { Wrapper: hn, LoadingIncicatorWrapper: bn };
function Qn({
  elementStart: e,
  elementEnd: n,
  progress: o,
  className: t
}) {
  return /* @__PURE__ */ l.jsxs(je.Wrapper, { className: t, children: [
    e,
    Ca(o) && /* @__PURE__ */ l.jsx(je.LoadingIncicatorWrapper, { children: /* @__PURE__ */ l.jsx(di, { progress: o }) }),
    n
  ] });
}
const En = f.fieldset`
  border: 0;
  padding: 0;
`, vn = f.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--p-spacing-16);
`, xe = {
  Group: vn,
  Fieldset: En
}, kn = (e) => e ? typeof e.text < "u" : !1;
function Cn({
  disabled: e,
  error: n,
  legend: o,
  name: t,
  onBlur: c,
  onChange: u,
  options: b,
  value: h,
  type: p,
  size: R = "large",
  cardAriaDescribedby: S,
  "aria-labelledby": d,
  ...I
}) {
  const E = p === "radio";
  return /* @__PURE__ */ l.jsxs(
    xe.Fieldset,
    {
      ...I,
      role: E ? "radiogroup" : void 0,
      "aria-labelledby": d,
      children: [
        kn(o) ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(we, { title: o.text, hint: o.hint }),
          /* @__PURE__ */ l.jsx(ua, { size: "16" })
        ] }) : o,
        /* @__PURE__ */ l.jsx(xe.Group, { children: b.map(
          ({
            value: v,
            hasError: G,
            disabled: F,
            trackId: B,
            ...j
          }) => /* @__PURE__ */ ii(
            Ci,
            {
              ...j,
              checked: Array.isArray(h) ? h.includes(v) : h === v,
              "data-trackid": B,
              disabled: F ?? e,
              hasError: G ?? !!n,
              key: v,
              name: E ? t : v,
              onBlur: c,
              onChange: u,
              type: p,
              value: v,
              size: R,
              "aria-describedby": S
            }
          )
        ) }),
        n && typeof n == "string" && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(ua, { size: "16" }),
          /* @__PURE__ */ l.jsx(Qa, { title: n, variant: "error", role: "alert" })
        ] })
      ]
    }
  );
}
const jn = f.div`
  text-align: center;
`, xn = f.div`
  margin: var(--p-spacing-32) 0 var(--p-spacing-24);

  > * {
    width: 100%;
    max-width: 110px;
    min-width: 80px;
  }
`, Sn = f(Ae)`
  text-align: center;
  margin-bottom: var(--p-spacing-16);
`, wn = f.div`
  margin-bottom: var(--p-spacing-32);

  p {
    text-align: center;
  }
`, Rn = f.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--p-spacing-24);
`, wa = {
  Container: jn,
  Figure: xn,
  Heading: Sn,
  Description: wn,
  ActionsContainer: Rn
}, ar = X(
  ({ figure: e, heading: n, description: o, actions: t, headingProps: c, ...u }, b) => /* @__PURE__ */ l.jsxs(wa.Container, { ...u, ref: b, children: [
    e && /* @__PURE__ */ l.jsx(wa.Figure, { children: e }),
    typeof n == "string" ? /* @__PURE__ */ l.jsx(wa.Heading, { htmlTag: "h1", ...c, children: n }) : n,
    o && /* @__PURE__ */ l.jsx(wa.Description, { children: typeof o == "string" ? /* @__PURE__ */ l.jsx("p", { children: o }) : o }),
    t && /* @__PURE__ */ l.jsx(wa.ActionsContainer, { children: t })
  ] })
);
export {
  Jn as ApplicationProcessPageLayout,
  qn as BooleanPillGroup,
  On as CenteredLoadingIndicator,
  zn as CheckCircleList,
  Ie as Container,
  a as CountryCode,
  Hn as EnergyBadge,
  Kn as EnergyBar,
  Q as EnergyBarColor,
  Zn as ErrorBoundary,
  Un as Frame,
  Ae as Heading,
  Xn as HeadingRow,
  Yn as InnerHtml,
  Vn as NumericInput,
  Wn as PhoneInput,
  Qn as ProgressBarRow,
  Ci as SelectionCard,
  Cn as SelectionCardGroup,
  ar as StatusLayout
};
